/**
 * MoosSchmiede Wand-Planer
 * Phase 3: Gruppen · Mehrfachauswahl · Undo · Persistenz
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function trackWandPlaner(eventName, params) {
    const payload = Object.assign({ event: eventName }, params || {});
    window.dataLayer.push(payload);
  }

  const DEFAULT_WALL_WIDTH_CM = 400;
  const DEFAULT_WALL_HEIGHT_CM = 260;
  const WALL_WIDTH_MIN_CM = 80;
  const WALL_WIDTH_MAX_CM = 600;
  const WALL_HEIGHT_MIN_CM = 200;
  const WALL_HEIGHT_MAX_CM = 450;
  const PREVIEW_PX_PER_CM = 3;
  const OUTLET_HEIGHT_ABOVE_FLOOR_CM = 30;
  /** Sichtbarer Rahmen — Außenkante = Produktmaß (31 cm usw.) */
  const MOSAIC_FRAME_STROKE_CM = 0.2;
  const STORAGE_KEY = 'wand-planer-state';
  const UNDO_STACK_MAX = 30;
  const TOOLBAR_FLIP_PX = 34;
  const MIN_HIT_PX = 40;

  /** Shop-Links — '#' = Platzhalter, kein Link anzeigen */
  const PRODUCT_URLS = {
    S: 'https://moosschmiede.de/products/moosbild-hexagon-mit-islandmoos-plattenmoos-und-kugelmoos-3-grossen-21-26-31cm',
    M: 'https://moosschmiede.de/products/moosbild-hexagon-mit-islandmoos-plattenmoos-und-kugelmoos-3-grossen-21-26-31cm',
    L: 'https://moosschmiede.de/products/moosbild-hexagon-mit-islandmoos-plattenmoos-und-kugelmoos-3-grossen-21-26-31cm',
    R30: 'https://moosschmiede.de/products/rundes-moosbild-30-40cm-set',
    R40: 'https://moosschmiede.de/products/rundes-moosbild-30-40cm-set',
    R50: 'https://moosschmiede.de/products/grosses-moosbild-rund-50-70-cm-islandmoos-farn-amarant-pflegeleichte-wandkunst',
    R70: 'https://moosschmiede.de/products/grosses-moosbild-rund-50-70-cm-islandmoos-farn-amarant-pflegeleichte-wandkunst',
    REC2097: 'https://moosschmiede.de/products/moosbild-klein-ca-20x9-7cm-mitbringsel-oder-als-geschenkidee',
    REC30117: 'https://moosschmiede.de/products/moosbild-rechteck-mittel',
    REC40147: 'https://moosschmiede.de/products/moosbild-rechteckig-40cm',
    REC4520: 'https://moosschmiede.de/products/moosbild-45x20-extra-tief',
  };

  const WHATSAPP_DEFAULT = '491756143846';

  const SIZES = {
    S: { cm: 21, label: 'S', title: 'Klein — 21 cm' },
    M: { cm: 26, label: 'M', title: 'Mittel — 26 cm' },
    L: { cm: 31, label: 'L', title: 'Groß — 31 cm' },
  };

  const ROUND_SIZES = {
    R30: { cm: 30, label: '30', title: 'Rund — 30 cm' },
    R40: { cm: 40, label: '40', title: 'Rund — 40 cm' },
    R50: { cm: 50, label: '50', title: 'Rund — 50 cm' },
    R70: { cm: 70, label: '70', title: 'Rund — 70 cm' },
  };

  /** Shop-Maße (Außenkante Rahmen) — Quelle: Produktvarianten / Titel */
  const RECT_SIZES = {
    REC2097: {
      widthCm: 20,
      heightCm: 9.7,
      label: '20×9,7',
      title: 'Rechteck — 20 × 9,7 cm',
    },
    REC30117: {
      widthCm: 30,
      heightCm: 11.7,
      label: '30×11,7',
      title: 'Rechteck — 30 × 11,7 cm',
    },
    REC40147: {
      widthCm: 40,
      heightCm: 14.7,
      label: '40×14,7',
      title: 'Rechteck — 40 × 14,7 cm',
    },
    REC4520: {
      widthCm: 45,
      heightCm: 20,
      label: '45×20',
      title: 'Rechteck — 45 × 20 cm',
    },
  };

  /** Alte Session-Keys → aktuelle Shop-Keys */
  const RECT_SHAPE_ALIASES = {
    REC4015: 'REC40147',
  };

  const MOSAIC_KINDS = ['hex', 'round', 'rect'];

  function isMosaicItem(item) {
    return item && MOSAIC_KINDS.includes(item.kind);
  }

  /** Illustration Frontansicht — Maßstab 54×180 (cm), angelehnt an Raum-Hilfen-Skizze */
  const PERSON_SILHOUETTE = {
    viewBox: '0 0 54 180',
    widthCm: 54,
    heightCm: 180,
  };

  function personSilhouetteSvg(className, width, height) {
    const vb = PERSON_SILHOUETTE.viewBox;
    return `
      <svg class="${className}" width="${width}" height="${height}" viewBox="${vb}" aria-hidden="true">
        <g class="wand-planer__ref-person-art">
          <path class="wand-planer__ref-person-pants" d="
            M 20.5 104
            L 17 156
            L 12.5 176
            L 22.5 176
            L 23.5 155
            L 27 155
            L 28 176
            L 38 176
            L 33.5 156
            L 30.5 104
            Z"></path>
          <path class="wand-planer__ref-person-hoodie" d="
            M 14.5 37
            C 9.5 43 8 55 8.5 69
            L 7.5 99
            C 7.5 102.5 10.5 104.5 14 104
            L 20.5 104
            L 30.5 104
            L 37 104
            C 40.5 104.5 43.5 102.5 43.5 99
            L 42.5 69
            C 43 55 41.5 43 36.5 37
            L 33 33
            C 30 29 24 29 21 33
            Z"></path>
          <path class="wand-planer__ref-person-hood" d="
            M 19.5 33
            C 17 25 21.5 18.5 27 18
            C 33 18.5 37.5 24.5 36 32.5
            L 33 33
            C 29.5 30.5 24.5 30.5 21 33
            Z"></path>
          <path class="wand-planer__ref-person-arms" d="
            M 11 44
            C 7.5 50 7 60 9 70
            L 13 74
            L 16.5 59
            L 21 71
            L 27 62.5
            L 33 71
            L 37.5 59
            L 41 74
            L 45 70
            C 47 60 46.5 50 43 44
            L 39 49
            L 27 60
            L 15 49
            Z"></path>
          <ellipse class="wand-planer__ref-person-head" cx="27" cy="23.5" rx="8.8" ry="10.2"></ellipse>
          <path class="wand-planer__ref-person-hair" d="
            M 18 17.5
            C 15.5 9.5 21 4.5 27 4
            C 33.5 4.5 38.5 9 38 17
            C 40 12.5 42 16.5 40 22
            C 37.5 27 34.5 27.5 32.5 23.5
            C 30.5 27.5 27.5 28.5 25 25.5
            C 22 28.5 19 27 18.5 22.5
            C 16.5 23.5 16 19.5 18 17.5
            Z"></path>
          <path class="wand-planer__ref-person-shoes" d="
            M 11.5 174.5
            C 10.5 177 11.5 179.5 14 179.5
            L 22.5 179.5
            C 24.5 179.5 25.5 177.5 25 175
            L 23.5 171
            L 12.5 171
            Z
            M 29 175
            C 28.5 177.5 29.5 179.5 31.5 179.5
            L 39.5 179.5
            C 41.5 179.5 42.5 177.5 41.5 175
            L 39.5 171
            L 28.5 171
            Z"></path>
        </g>
      </svg>
    `.replace(/\s+/g, ' ').trim();
  }

  const REF_TYPES = {
    sofa: {
      widthCm: 200,
      heightCm: 85,
      title: 'Sofa',
      label: 'Sofa — ca. 200 × 85 cm',
      floorAlign: true,
      resizable: true,
      minWidthCm: 120,
      maxWidthCm: 350,
      minHeightCm: 55,
      maxHeightCm: 120,
    },
    sideboard: {
      widthCm: 180,
      heightCm: 75,
      title: 'Sideboard',
      label: 'Sideboard — ca. 180 × 75 cm',
      floorAlign: true,
      resizable: true,
      minWidthCm: 80,
      maxWidthCm: 300,
      minHeightCm: 40,
      maxHeightCm: 110,
    },
    person: {
      widthCm: PERSON_SILHOUETTE.widthCm,
      heightCm: PERSON_SILHOUETTE.heightCm,
      title: 'Person',
      label: 'Person — ca. 180 cm',
      floorAlign: true,
    },
    door: {
      widthCm: 90,
      heightCm: 210,
      title: 'Tür',
      label: 'Tür — ca. 210 × 90 cm',
      floorAlign: true,
    },
    window: {
      widthCm: 120,
      heightCm: 120,
      title: 'Fenster',
      label: 'Fenster — ca. 120 × 120 cm',
      floorAlign: true,
    },
    outlet: {
      widthCm: 8.6,
      heightCm: 8.6,
      title: 'Steckdose',
      label: 'Steckdose — ca. 8,6 cm',
      floorAlign: 'outlet',
    },
  };

  function refDisplayTitle(item) {
    const ref = REF_TYPES[item?.refKey];
    if (!ref) return 'Raum-Hilfe';
    if (ref.resizable) {
      return `${ref.title} — ${formatDimCm(item.widthCm)} × ${formatDimCm(item.heightCm)} cm`;
    }
    return ref.label || ref.title;
  }

  function parseCmInput(raw, minCm, maxCm) {
    const normalized = String(raw).trim().replace(',', '.');
    const value = parseFloat(normalized);
    if (Number.isNaN(value) || value <= 0) return null;
    return clamp(round1(value), minCm, maxCm);
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function round1(value) {
    return Math.round(value * 10) / 10;
  }

  function mosaicStrokePx(pxPerCm) {
    return MOSAIC_FRAME_STROKE_CM * pxPerCm;
  }

  /** Flat-top bei 0° — rotationDeg dreht die Eckpunkte direkt (kein SVG-transform). */
  function hexGeometry(diameterCm, pxPerCm, rotationDeg = 0) {
    const strokePx = mosaicStrokePx(pxPerCm);
    const width = diameterCm * pxPerCm;
    const height = (width * Math.sqrt(3)) / 2;
    const r = width / 2 - strokePx / 2;
    const cx = width / 2;
    const cy = height / 2;
    const rotOffset = (rotationDeg * Math.PI) / 180;
    const points = [];

    for (let i = 0; i < 6; i++) {
      const angle = (Math.PI / 3) * i + rotOffset;
      points.push(
        `${(cx + r * Math.cos(angle)).toFixed(2)},${(cy + r * Math.sin(angle)).toFixed(2)}`
      );
    }

    return {
      width,
      height,
      heightCm: (diameterCm * Math.sqrt(3)) / 2,
      strokePx,
      points: points.join(' '),
      labelX: cx,
      labelY: cy,
      markerX: cx + (r - strokePx) * Math.cos(rotOffset),
      markerY: cy + (r - strokePx) * Math.sin(rotOffset),
    };
  }

  function parseWallMeasure(raw, minCm, maxCm) {
    const normalized = String(raw).trim().replace(',', '.');
    const value = parseFloat(normalized);
    if (Number.isNaN(value) || value <= 0) return null;
    if (value <= 6) return clamp(round1(value * 100), minCm, maxCm);
    return clamp(round1(value), minCm, maxCm);
  }

  function hexHeightCm(diameterCm) {
    return hexGeometry(diameterCm, 1).heightCm;
  }

  /** Flat-top: waagerechter Abstand Mittelpunkt zu Mittelpunkt in einer Reihe */
  function hexRowSpacingCm(diameterCm) {
    return diameterCm * 0.75;
  }

  /** Flat-top: vertikaler Versatz schräge Fläche an Fläche = h/2 (nicht Pointy-Top 0,75·h) */
  function hexColSpacingCm(diameterCm) {
    return hexHeightCm(diameterCm) * 0.5;
  }

  function rotateOffsetCm(dx, dy, rotationDeg = 0) {
    if (!rotationDeg) return { dx, dy };
    const rad = (rotationDeg * Math.PI) / 180;
    return {
      dx: dx * Math.cos(rad) - dy * Math.sin(rad),
      dy: dx * Math.sin(rad) + dy * Math.cos(rad),
    };
  }

  function applyGapToOffset(dx, dy, gap) {
    if (gap <= 0 || (Math.abs(dx) < 0.001 && Math.abs(dy) < 0.001)) {
      return { dx, dy };
    }
    const len = Math.hypot(dx, dy);
    return {
      dx: dx + (dx / len) * gap,
      dy: dy + (dy / len) * gap,
    };
  }

  /** Flat-top: Mittelpunkt-zu-Mittelpunkt-Kontakte für zwei Hex-Größen (gleiche Rotation) */
  function hexContactCenterOffsets(dItem, dOther, gap, rotationDeg = 0) {
    const hItem = hexHeightCm(dItem);
    const hOther = hexHeightCm(dOther);
    const halfSumD = (dItem + dOther) / 2 + gap;
    const halfSumH = (hItem + hOther) / 2 + gap;
    const slantM = (hItem + hOther) / 2 + gap;
    const cos30 = Math.sqrt(3) / 2;
    const sin30 = 0.5;

    const base = [
      { dx: halfSumD, dy: 0, mode: 'point-x' },
      { dx: -halfSumD, dy: 0, mode: 'point-x' },
      { dx: 0, dy: halfSumH, mode: 'flat-y' },
      { dx: 0, dy: -halfSumH, mode: 'flat-y' },
      { dx: slantM * cos30, dy: slantM * sin30, mode: 'zigzag' },
      { dx: slantM * cos30, dy: -slantM * sin30, mode: 'zigzag' },
      { dx: -slantM * cos30, dy: slantM * sin30, mode: 'zigzag' },
      { dx: -slantM * cos30, dy: -slantM * sin30, mode: 'zigzag' },
    ];

    return base.map(({ dx, dy, mode }) => {
      const rotated = rotateOffsetCm(dx, dy, rotationDeg);
      let tangent = null;
      if (mode === 'flat-y') {
        tangent = rotateOffsetCm(1, 0, rotationDeg);
      } else if (mode === 'zigzag') {
        const len = Math.hypot(dx, dy) || 1;
        tangent = rotateOffsetCm(-dy / len, dx / len, rotationDeg);
      }
      return { ...rotated, mode, tangent };
    });
  }

  function hexBoundsCenter(local) {
    return {
      cx: (local.minX + local.maxX) / 2,
      cy: (local.minY + local.maxY) / 2,
    };
  }

  function scoreHexSnapSlot(xCm, yCm, slot, relaxed) {
    const euclid = Math.hypot(xCm - slot.xCm, yCm - slot.yCm);
    const threshold = relaxed ? 15 : 12;
    return euclid <= threshold ? euclid : null;
  }

  function getHexWorldCenter(item) {
    const local = getHexLocalBounds(item.cm, item.rotationDeg || 0);
    const center = hexBoundsCenter(local);
    return {
      x: item.xCm + center.cx,
      y: item.yCm + center.cy,
    };
  }

  /**
   * Mittelpunkt-Deltas (item relativ zu other) inkl. Gap + Tangenten bei ungleichen Größen.
   * Gleiche Formel wie die Snap-Slots — eine Quelle für Einrasten und Abstands-Umbau.
   */
  function hexNeighborCenterDeltas(dItem, dOther, gap, rotationDeg = 0) {
    const sameSize = dItem === dOther;
    const tangentShift = sameSize ? 0 : (dItem - dOther) / 4;
    const deltas = [];

    hexContactCenterOffsets(dItem, dOther, 0, rotationDeg).forEach(({ dx, dy, mode, tangent }) => {
      const len = Math.hypot(dx, dy) || 1;
      const normalDx = dx / len;
      const normalDy = dy / len;
      let contactDx = dx;
      let contactDy = dy;

      if (mode === 'point-x') {
        contactDx = Math.sign(dx || 1) * ((dItem + dOther) / 2 + gap);
        contactDy = 0;
      } else if (sameSize) {
        if (mode === 'flat-y') {
          contactDy = Math.sign(dy || 1) * ((hexHeightCm(dItem) + hexHeightCm(dOther)) / 2 + gap);
          contactDx = 0;
        } else {
          const slantM = (hexHeightCm(dItem) + hexHeightCm(dOther)) / 2 + gap;
          contactDx = slantM * normalDx;
          contactDy = slantM * normalDy;
        }
      } else if (gap > 0) {
        contactDx += gap * normalDx;
        contactDy += gap * normalDy;
      }

      if (sameSize || mode === 'point-x' || !tangent) {
        deltas.push({ dx: contactDx, dy: contactDy, mode });
        return;
      }

      deltas.push({
        dx: contactDx + tangentShift * tangent.dx,
        dy: contactDy + tangentShift * tangent.dy,
        mode,
      });
      deltas.push({
        dx: contactDx - tangentShift * tangent.dx,
        dy: contactDy - tangentShift * tangent.dy,
        mode,
      });
    });

    return deltas;
  }

  /** Paare, die bei aktuellem Gap praktisch Flächenkontakt haben */
  function findHexContactPairs(items, gap, toleranceCm = 3.2) {
    const hexes = items.filter((item) => item.kind === 'hex');
    const pairs = [];

    for (let i = 0; i < hexes.length; i += 1) {
      for (let j = i + 1; j < hexes.length; j += 1) {
        const a = hexes[i];
        const b = hexes[j];
        if ((a.rotationDeg || 0) !== (b.rotationDeg || 0)) continue;

        const ca = getHexWorldCenter(a);
        const cb = getHexWorldCenter(b);
        const adx = cb.x - ca.x;
        const ady = cb.y - ca.y;
        let best = null;

        hexNeighborCenterDeltas(b.cm, a.cm, gap, a.rotationDeg || 0).forEach(({ dx, dy, mode }) => {
          const err = Math.hypot(adx - dx, ady - dy);
          if (err <= toleranceCm && (!best || err < best.err)) {
            best = { err, dx, dy, mode };
          }
        });

        if (best) {
          pairs.push({ a, b, ox: best.dx, oy: best.dy, mode: best.mode });
        }
      }
    }

    return pairs;
  }

  function matchNeighborDelta(dItem, dOther, gap, rotationDeg, refDx, refDy) {
    const refLen = Math.hypot(refDx, refDy) || 1;
    let best = null;

    hexNeighborCenterDeltas(dItem, dOther, gap, rotationDeg).forEach(({ dx, dy, mode }) => {
      const len = Math.hypot(dx, dy) || 1;
      const cos = (dx * refDx + dy * refDy) / (len * refLen);
      if (!best || cos > best.cos) {
        best = { dx, dy, mode, cos };
      }
    });

    return best;
  }

  function collectHexSnapSlots(item, other, gap) {
    if (item.kind !== 'hex' || other.kind !== 'hex') return [];
    if ((item.rotationDeg || 0) !== (other.rotationDeg || 0)) return [];

    const rotationDeg = item.rotationDeg || 0;
    const itemLocal = getMosaicLocalBounds(item);
    const otherLocal = getMosaicLocalBounds(other);
    const itemCenter = hexBoundsCenter(itemLocal);
    const otherCenter = hexBoundsCenter(otherLocal);
    const centerOtherWorld = {
      x: other.xCm + otherCenter.cx,
      y: other.yCm + otherCenter.cy,
    };

    return hexNeighborCenterDeltas(item.cm, other.cm, gap, rotationDeg).map(({ dx, dy, mode }) => ({
      xCm: centerOtherWorld.x + dx - itemCenter.cx,
      yCm: centerOtherWorld.y + dy - itemCenter.cy,
      kind: mode,
    }));
  }

  function snapMosaicPosition(item, xCm, yCm, items, wallWidthCm, wallHeightCm, gapCm = 0, options = {}) {
    if (!isMosaicItem(item)) {
      return { xCm: round1(Math.round(xCm)), yCm: round1(Math.round(yCm)), snapped: false };
    }

    const relaxed = Boolean(options.relaxed);
    const axisThreshold = relaxed ? 7 : 5;
    const gap = Math.max(0, gapCm || 0);
    const local = getMosaicLocalBounds(item);

    let bestHexSlot = null;
    let bestHexScore = Infinity;

    items
      .filter((other) => other.id !== item.id && isMosaicItem(other))
      .forEach((other) => {
        if (item.kind === 'hex' && other.kind === 'hex') {
          collectHexSnapSlots(item, other, gap).forEach((slot) => {
            const score = scoreHexSnapSlot(xCm, yCm, slot, relaxed);
            if (score !== null && score < bestHexScore) {
              bestHexScore = score;
              bestHexSlot = slot;
            }
          });
        }
      });

    if (bestHexSlot) {
      return {
        xCm: round1(bestHexSlot.xCm),
        yCm: round1(bestHexSlot.yCm),
        snapped: true,
      };
    }

    let bestX = null;
    let bestXDist = axisThreshold;
    let bestY = null;
    let bestYDist = axisThreshold;

    const considerX = (targetX) => {
      const dist = Math.abs(xCm - targetX);
      if (dist <= axisThreshold && dist < bestXDist) {
        bestXDist = dist;
        bestX = round1(targetX);
      }
    };

    const considerY = (targetY) => {
      const dist = Math.abs(yCm - targetY);
      if (dist <= axisThreshold && dist < bestYDist) {
        bestYDist = dist;
        bestY = round1(targetY);
      }
    };

    items
      .filter((other) => other.id !== item.id && isMosaicItem(other))
      .forEach((other) => {
        if (item.kind === 'hex' && other.kind === 'hex') {
          return;
        }

        const otherBounds = getMosaicWorldBoundsAt(other, other.xCm, other.yCm);
        const otherLocal = getMosaicLocalBounds(other);

        considerX(otherBounds.maxX + gap - local.minX);
        considerX(otherBounds.minX - gap - local.maxX);
        considerY(otherBounds.maxY + gap - local.minY);
        considerY(otherBounds.minY - gap - local.maxY);
        considerY(other.yCm + otherLocal.minY - local.minY);
        considerX(other.xCm + otherLocal.minX - local.minX);
      });

    if (typeof wallWidthCm === 'number') {
      considerX(-local.minX);
      considerX(wallWidthCm - local.maxX);
    }

    if (typeof wallHeightCm === 'number') {
      considerY(-local.minY);
      considerY(wallHeightCm - local.maxY);
    }

    const snapped = bestX !== null || bestY !== null;

    return {
      xCm: bestX !== null ? bestX : round1(Math.round(xCm)),
      yCm: bestY !== null ? bestY : round1(Math.round(yCm)),
      snapped,
    };
  }

  /** Flat-top Axial → Mittelpunkt (cm), size = Spitze-zu-Spitze d */
  function axialCenterCm(q, r, d) {
    const h = hexHeightCm(d);
    return {
      cx: 0.75 * d * q,
      cy: h * (r + q / 2),
    };
  }

  function hexOriginFromCenter(sizeKey, cx, cy) {
    const local = getHexLocalBounds(SIZES[sizeKey].cm, 0);
    const center = hexBoundsCenter(local);
    return {
      sizeKey,
      xCm: cx - center.cx,
      yCm: cy - center.cy,
    };
  }

  function centerPlacementsOnWall(raw, centerX, centerY) {
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    const withBounds = raw.map((p) => {
      const local = getHexLocalBounds(SIZES[p.sizeKey].cm, 0);
      const bounds = {
        minX: p.xCm + local.minX,
        minY: p.yCm + local.minY,
        maxX: p.xCm + local.maxX,
        maxY: p.yCm + local.maxY,
      };
      minX = Math.min(minX, bounds.minX);
      minY = Math.min(minY, bounds.minY);
      maxX = Math.max(maxX, bounds.maxX);
      maxY = Math.max(maxY, bounds.maxY);
      return p;
    });

    const bw = maxX - minX;
    const bh = maxY - minY;
    const ox = centerX - bw / 2 - minX;
    const oy = centerY - bh / 2 - minY;

    return withBounds.map((p) => ({
      sizeKey: p.sizeKey,
      xCm: round1(p.xCm + ox),
      yCm: round1(p.yCm + oy),
    }));
  }

  /** Gleiche Größe: Axial-Zellen → Wand-Platzierungen */
  function buildSameSizeAxial(sizeKey, cells, centerX, centerY) {
    const d = SIZES[sizeKey].cm;
    const raw = cells.map(([q, r]) => {
      const { cx, cy } = axialCenterCm(q, r, d);
      return hexOriginFromCenter(sizeKey, cx, cy);
    });
    return centerPlacementsOnWall(raw, centerX, centerY);
  }

  /** Kette entlang SE (+) oder NE (−) mit Flächenkontakt (auch gemischte Größen) */
  function buildContactChain(sizeKeys, direction, centerX, centerY) {
    const cos30 = Math.sqrt(3) / 2;
    const sin30 = 0.5;
    let cx = 0;
    let cy = 0;
    const raw = [];

    sizeKeys.forEach((sizeKey, index) => {
      if (index === 0) {
        raw.push(hexOriginFromCenter(sizeKey, cx, cy));
        return;
      }
      const prev = sizeKeys[index - 1];
      const hPrev = hexHeightCm(SIZES[prev].cm);
      const hNext = hexHeightCm(SIZES[sizeKey].cm);
      const slantM = (hPrev + hNext) / 2;
      const signY = direction === 'ne' ? -1 : 1;
      cx += slantM * cos30;
      cy += signY * slantM * sin30;
      raw.push(hexOriginFromCenter(sizeKey, cx, cy));
    });

    return centerPlacementsOnWall(raw, centerX, centerY);
  }

  /** Schritte: 'ne' | 'se' | 's' | 'n' | 'nw' | 'sw' — Flächenkontakt, gemischte Größen ok */
  function buildZigzagSteps(sizeKeys, steps, centerX, centerY) {
    const cos30 = Math.sqrt(3) / 2;
    const sin30 = 0.5;
    let cx = 0;
    let cy = 0;
    const raw = [hexOriginFromCenter(sizeKeys[0], cx, cy)];

    for (let i = 1; i < sizeKeys.length; i++) {
      const prev = sizeKeys[i - 1];
      const next = sizeKeys[i];
      const hPrev = hexHeightCm(SIZES[prev].cm);
      const hNext = hexHeightCm(SIZES[next].cm);
      const dPrev = SIZES[prev].cm;
      const dNext = SIZES[next].cm;
      const slantM = (hPrev + hNext) / 2;
      const flatYM = (hPrev + hNext) / 2;
      const step = steps[i - 1];

      if (step === 'ne') {
        cx += slantM * cos30;
        cy -= slantM * sin30;
      } else if (step === 'se') {
        cx += slantM * cos30;
        cy += slantM * sin30;
      } else if (step === 'nw') {
        cx -= slantM * cos30;
        cy -= slantM * sin30;
      } else if (step === 'sw') {
        cx -= slantM * cos30;
        cy += slantM * sin30;
      } else if (step === 's') {
        cy += flatYM;
      } else if (step === 'n') {
        cy -= flatYM;
      } else if (step === 'e') {
        cx += (dPrev + dNext) / 2;
      } else if (step === 'w') {
        cx -= (dPrev + dNext) / 2;
      }

      raw.push(hexOriginFromCenter(next, cx, cy));
    }

    return centerPlacementsOnWall(raw, centerX, centerY);
  }

  function mergeClusters(clusters, centerX, centerY, gapCm = 8) {
    let cursorX = 0;
    const merged = [];
    clusters.forEach((cluster, index) => {
      let minX = Infinity;
      let maxX = -Infinity;
      let minY = Infinity;
      let maxY = -Infinity;
      cluster.forEach((p) => {
        const local = getHexLocalBounds(SIZES[p.sizeKey].cm, 0);
        minX = Math.min(minX, p.xCm + local.minX);
        maxX = Math.max(maxX, p.xCm + local.maxX);
        minY = Math.min(minY, p.yCm + local.minY);
        maxY = Math.max(maxY, p.yCm + local.maxY);
      });
      const width = maxX - minX;
      const height = maxY - minY;
      const shiftX = cursorX - minX;
      const shiftY = -minY - height / 2;
      cluster.forEach((p) => {
        merged.push({
          sizeKey: p.sizeKey,
          xCm: p.xCm + shiftX,
          yCm: p.yCm + shiftY,
        });
      });
      cursorX += width + (index < clusters.length - 1 ? gapCm : 0);
    });
    return centerPlacementsOnWall(merged, centerX, centerY);
  }

  /** Shop-Skizze Honey-Grid: 7× M Zickzack (nicht Blume) */
  function buildHoneyGrid7M(centerX, centerY) {
    return buildSameSizeAxial(
      'M',
      [
        [0, 0],
        [1, -1],
        [2, -2],
        [3, -2],
        [4, -3],
        [5, -4],
        [6, -4],
      ],
      centerX,
      centerY
    );
  }

  function buildDesktopTrio(centerX, centerY) {
    return buildSameSizeAxial('S', [[0, 0], [0, 1], [0, 2]], centerX, centerY);
  }

  function buildFokusTrio(centerX, centerY) {
    return buildContactChain(['L', 'M', 'S'], 'se', centerX, centerY);
  }

  function buildDeepWorkWabe(centerX, centerY) {
    // Skizze ~85×67: Top + 3 darunter, dann 2 weiter rechts/unten
    return buildSameSizeAxial(
      'M',
      [
        [0, -1],
        [-1, 0],
        [0, 0],
        [1, -1],
        [2, -1],
        [2, 0],
      ],
      centerX,
      centerY
    );
  }

  function buildSmallOffice(centerX, centerY) {
    // Skizze ~52,5×67: Treppe 1 | 2 | 2
    return buildSameSizeAxial(
      'S',
      [
        [0, 0],
        [1, -1],
        [1, 0],
        [2, 0],
        [2, 1],
      ],
      centerX,
      centerY
    );
  }

  function buildDynamicContrast(centerX, centerY) {
    // Skizze ~78×53: 3× L links (1 + Stapel), S in der V-Tasche, 2× S rechts
    const dL = SIZES.L.cm;
    const hL = hexHeightCm(dL);
    const hsL = hexRowSpacingCm(dL);
    const vsL = hexColSpacingCm(dL);
    const centers = [];

    centers.push({ sizeKey: 'L', cx: 0, cy: 0 });
    centers.push({ sizeKey: 'L', cx: hsL, cy: -vsL });
    centers.push({ sizeKey: 'L', cx: hsL, cy: vsL });

    const slantLS = (hL + hexHeightCm(SIZES.S.cm)) / 2;
    const cos30 = Math.sqrt(3) / 2;
    const sin30 = 0.5;
    const sMid = {
      sizeKey: 'S',
      cx: hsL + slantLS * cos30,
      cy: 0,
    };
    centers.push(sMid);

    const dS = SIZES.S.cm;
    const hsS = hexRowSpacingCm(dS);
    const vsS = hexColSpacingCm(dS);
    centers.push({ sizeKey: 'S', cx: sMid.cx + hsS, cy: sMid.cy - vsS });
    centers.push({ sizeKey: 'S', cx: sMid.cx + hsS, cy: sMid.cy + vsS });

    const raw = centers.map((c) => hexOriginFromCenter(c.sizeKey, c.cx, c.cy));
    return centerPlacementsOnWall(raw, centerX, centerY);
  }

  function buildWohnlandschaft(centerX, centerY) {
    // Skizze ~105×49,5: L→L→L→M→M→M mit NE,SE,NE,NE,SE
    return buildZigzagSteps(
      ['L', 'L', 'L', 'M', 'M', 'M'],
      ['ne', 'se', 'ne', 'ne', 'se'],
      centerX,
      centerY
    );
  }

  function buildTripleHarmony(centerX, centerY) {
    // Drei getrennte Cluster wie Shop-Skizze über Sideboard
    const clusterM = buildSameSizeAxial('M', [[0, 0], [0, 1], [1, 0]], 0, 0);
    const clusterS = buildSameSizeAxial('S', [[0, 0], [-1, 1], [1, 0]], 0, 0);
    const clusterL = buildContactChain(['L', 'L', 'L'], 'se', 0, 0);
    return mergeClusters([clusterM, clusterS, clusterL], centerX, centerY, 12);
  }

  function buildGrandStatement(centerX, centerY) {
    // Shop-Skizze ~210×66: Welle 4×S · 4×M · 5×L (Sideboard-Layout)
    const cos30 = Math.sqrt(3) / 2;
    const sin30 = 0.5;
    const centers = [];

    function stepFrom(from, toKey, dir) {
      const hFrom = hexHeightCm(SIZES[from.sizeKey].cm);
      const hTo = hexHeightCm(SIZES[toKey].cm);
      const slantM = (hFrom + hTo) / 2;
      let { cx, cy } = from;
      if (dir === 'ne') {
        cx += slantM * cos30;
        cy -= slantM * sin30;
      } else if (dir === 'se') {
        cx += slantM * cos30;
        cy += slantM * sin30;
      } else if (dir === 's') {
        cy += slantM;
      } else if (dir === 'n') {
        cy -= slantM;
      }
      const next = { sizeKey: toKey, cx, cy };
      centers.push(next);
      return next;
    }

    // S: Start → SE → NE (Spalte oben) → S (Spalte unten)
    const s0 = { sizeKey: 'S', cx: 0, cy: 0 };
    centers.push(s0);
    const s1 = stepFrom(s0, 'S', 'se');
    const sColTop = stepFrom(s1, 'S', 'ne');
    stepFrom(sColTop, 'S', 's');

    // M: höher rechts an S-Spalte → SE-Spalte → rechts eingenistet
    const m0 = stepFrom(sColTop, 'M', 'ne');
    const mColTop = stepFrom(m0, 'M', 'se');
    stepFrom(mColTop, 'M', 's');
    const mRight = stepFrom(mColTop, 'M', 'se');

    // L: weiter rechts → NE → Peak-Spalte → Auslauf SE
    const l0 = stepFrom(mRight, 'L', 'se');
    const l1 = stepFrom(l0, 'L', 'ne');
    const lPeak = stepFrom(l1, 'L', 'ne');
    const lUnder = stepFrom(lPeak, 'L', 's');
    stepFrom(lUnder, 'L', 'se');

    const raw = centers.map((c) => hexOriginFromCenter(c.sizeKey, c.cx, c.cy));
    return centerPlacementsOnWall(raw, centerX, centerY);
  }

  const SET_TEMPLATES = {
    'fokus-trio': {
      name: 'Fokus Trio',
      meta: '1× S · 1× M · 1× L',
      productHandle: 'moosbild-set-hexagon-fokus-trio-3-teilig-s-m-l',
      build: buildFokusTrio,
    },
    'desktop-trio': {
      name: 'Desktop-Trio',
      meta: '3× S',
      productHandle: 'moosbild-set-hexagon-desktop-trio-3-teilig-grosse-s',
      build: buildDesktopTrio,
    },
    'honey-grid': {
      name: 'Honey-Grid',
      meta: '7× M',
      productHandle: 'moosbild-set-hexagon-honey-grid-7-teilig-grosse-m',
      build: buildHoneyGrid7M,
    },
    'deep-work': {
      name: 'Deep Work Wabe',
      meta: '6× M',
      productHandle: 'moosbild-set-hexagon-deep-work-wabe-6-teilig-grosse-m',
      build: buildDeepWorkWabe,
    },
    'dynamic-contrast': {
      name: 'Dynamic Contrast',
      meta: '3× L · 3× S',
      productHandle: 'moosbild-set-hexagon-dynamic-contrast-6-teilig-3x-l-3x-s',
      build: buildDynamicContrast,
    },
    'small-office': {
      name: 'Small Office',
      meta: '5× S',
      productHandle: 'moosbild-set-hexagon-small-office-5-teilig-5x-s',
      build: buildSmallOffice,
    },
    'triple-harmony': {
      name: 'Triple Harmony',
      meta: '3× S · 3× M · 3× L',
      productHandle: 'moosbild-set-hexagon-triple-harmony-9-teilig-3x-s-3x-m-3x-l',
      build: buildTripleHarmony,
    },
    'grand-statement': {
      name: 'Grand Statement',
      meta: '4× S · 4× M · 5× L',
      productHandle: 'moosbild-set-hexagon-grand-statement-13-teilig-4x-s-4x-m-5x-l',
      build: buildGrandStatement,
    },
    wohnlandschaft: {
      name: 'Wohnlandschaft',
      meta: '3× L · 3× M',
      productHandle:
        'verwandle-dein-zuhause-mit-dem-6-teiligen-moosbild-set-hexagon-handgefertigt-in-ludinghausen-100-pflegefrei-schallabsorbierend-jetzt-natur-pur-geniessen',
      build: buildWohnlandschaft,
    },
  };

  function resolveRectShapeKey(shapeKey) {
    return RECT_SHAPE_ALIASES[shapeKey] || shapeKey;
  }

  function normalizePersistedItem(item) {
    if (!item) return item;
    if (item.kind === 'rect') {
      const shapeKey = resolveRectShapeKey(item.shapeKey);
      const spec = RECT_SIZES[shapeKey];
      if (!spec) return item;
      return {
        ...item,
        shapeKey,
        widthCm: spec.widthCm,
        heightCm: spec.heightCm,
      };
    }
    if (item.kind === 'ref') {
      const ref = REF_TYPES[item.refKey];
      if (!ref) return item;
      const widthCm =
        typeof item.widthCm === 'number'
          ? clamp(item.widthCm, ref.minWidthCm || ref.widthCm, ref.maxWidthCm || ref.widthCm)
          : ref.widthCm;
      const heightCm =
        typeof item.heightCm === 'number'
          ? clamp(item.heightCm, ref.minHeightCm || ref.heightCm, ref.maxHeightCm || ref.heightCm)
          : ref.heightCm;
      return { ...item, widthCm, heightCm };
    }
    return item;
  }

  function getMosaicSpec(kind, shapeKey) {
    if (kind === 'hex') return SIZES[shapeKey] ? { ...SIZES[shapeKey], kind: 'hex', shapeKey } : null;
    if (kind === 'round') return ROUND_SIZES[shapeKey] ? { ...ROUND_SIZES[shapeKey], kind: 'round', shapeKey } : null;
    if (kind === 'rect') {
      const resolved = resolveRectShapeKey(shapeKey);
      return RECT_SIZES[resolved] ? { ...RECT_SIZES[resolved], kind: 'rect', shapeKey: resolved } : null;
    }
    return null;
  }

  function getHexLocalBounds(cm, rotationDeg = 0) {
    const geom = hexGeometry(cm, 1, rotationDeg);
    const verts = geom.points.split(' ').map((pair) => {
      const [x, y] = pair.split(',').map(Number);
      return { x, y };
    });
    const pad = MOSAIC_FRAME_STROKE_CM / 2;
    const minX = Math.min(...verts.map((v) => v.x)) - pad;
    const minY = Math.min(...verts.map((v) => v.y)) - pad;
    const maxX = Math.max(...verts.map((v) => v.x)) + pad;
    const maxY = Math.max(...verts.map((v) => v.y)) + pad;
    return {
      minX,
      minY,
      maxX,
      maxY,
      widthCm: maxX - minX,
      heightCm: maxY - minY,
    };
  }

  function getHexWorldBoundsAt(item, xCm, yCm) {
    const local = getHexLocalBounds(item.cm, item.rotationDeg || 0);
    return {
      minX: xCm + local.minX,
      minY: yCm + local.minY,
      maxX: xCm + local.maxX,
      maxY: yCm + local.maxY,
      widthCm: local.widthCm,
      heightCm: local.heightCm,
    };
  }

  function getMosaicLocalBounds(item) {
    if (item.kind === 'hex') {
      return getHexLocalBounds(item.cm, item.rotationDeg || 0);
    }

    let w;
    let h;

    if (item.kind === 'round') {
      w = item.cm;
      h = item.cm;
    } else if (item.kind === 'rect') {
      const size = getItemUnrotatedSize(item);
      const rot = ((item.rotationDeg || 0) % 360 + 360) % 360;
      w = rot === 90 || rot === 270 ? size.heightCm : size.widthCm;
      h = rot === 90 || rot === 270 ? size.widthCm : size.heightCm;
    } else {
      return { minX: 0, minY: 0, maxX: 0, maxY: 0, widthCm: 0, heightCm: 0 };
    }

    // Außenmaß = Shop-Produktmaß; Rahmenstrich liegt innen in der SVG
    return {
      minX: 0,
      minY: 0,
      maxX: w,
      maxY: h,
      widthCm: w,
      heightCm: h,
    };
  }

  function getMosaicWorldBoundsAt(item, xCm, yCm) {
    if (item.kind === 'hex') {
      return getHexWorldBoundsAt(item, xCm, yCm);
    }

    const local = getMosaicLocalBounds(item);
    return {
      minX: xCm + local.minX,
      minY: yCm + local.minY,
      maxX: xCm + local.maxX,
      maxY: yCm + local.maxY,
      widthCm: local.widthCm,
      heightCm: local.heightCm,
    };
  }

  function getItemUnrotatedSize(item) {
    if (item.kind === 'hex') {
      const geom = hexGeometry(item.cm, 1);
      return { widthCm: item.cm, heightCm: geom.heightCm };
    }
    if (item.kind === 'round') {
      return { widthCm: item.cm, heightCm: item.cm };
    }
    if (item.kind === 'rect') {
      return { widthCm: item.widthCm, heightCm: item.heightCm };
    }
    return { widthCm: item.widthCm, heightCm: item.heightCm };
  }

  function getItemWorldBounds(item) {
    return getMosaicWorldBoundsAt(item, item.xCm, item.yCm);
  }

  function mosaicBoundsOverlap(a, b, padCm = 0.05) {
    return (
      a.minX < b.maxX - padCm &&
      a.maxX > b.minX + padCm &&
      a.minY < b.maxY - padCm &&
      a.maxY > b.minY + padCm
    );
  }

  function mosaicBoundsInsideWall(bounds, wallWidthCm, wallHeightCm) {
    return (
      bounds.minX >= -0.05 &&
      bounds.minY >= -0.05 &&
      bounds.maxX <= wallWidthCm + 0.05 &&
      bounds.maxY <= wallHeightCm + 0.05
    );
  }

  function getGroupMemberIds(items, groupId) {
    if (!groupId) return [];
    return items.filter((item) => item.groupId === groupId).map((item) => item.id);
  }

  function getItemsBounds(items, ids) {
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    ids.forEach((id) => {
      const item = items.find((i) => i.id === id);
      if (!item) return;
      const bounds = getItemWorldBounds(item);
      minX = Math.min(minX, bounds.minX);
      minY = Math.min(minY, bounds.minY);
      maxX = Math.max(maxX, bounds.maxX);
      maxY = Math.max(maxY, bounds.maxY);
    });

    if (!Number.isFinite(minX)) return null;
    return { minX, minY, maxX, maxY, widthCm: maxX - minX, heightCm: maxY - minY };
  }

  function clampItemsToWall(items, ids, wallWidthCm, wallHeightCm) {
    const box = getItemsBounds(items, ids);
    if (!box) return;

    let dx = 0;
    let dy = 0;
    if (box.minX < 0) dx = -box.minX;
    if (box.maxX > wallWidthCm) dx = wallWidthCm - box.maxX;
    if (box.minY < 0) dy = -box.minY;
    if (box.maxY > wallHeightCm) dy = wallHeightCm - box.maxY;

    if (Math.abs(dx) < 0.001 && Math.abs(dy) < 0.001) return;

    ids.forEach((id) => {
      const item = items.find((i) => i.id === id);
      if (!item) return;
      item.xCm = round1(item.xCm + dx);
      item.yCm = round1(item.yCm + dy);
    });
  }

  function applyItemTransform(el, item, pxPerCm) {
    const xPx = item.xCm * pxPerCm;
    const yPx = item.yCm * pxPerCm;
    el.style.transform = `translate(${xPx}px, ${yPx}px)`;
  }

  function mosaicTitle(item) {
    if (item.kind === 'hex') return SIZES[item.shapeKey].title;
    if (item.kind === 'round') return ROUND_SIZES[item.shapeKey].title;
    if (item.kind === 'rect') return RECT_SIZES[item.shapeKey].title;
    return 'Moosbild';
  }

  function renderMosaicSvg(item, pxPerCm) {
    const rot = item.rotationDeg || 0;

    if (item.kind === 'hex') {
      const geom = hexGeometry(item.cm, pxPerCm, rot);
      return `
        <svg class="wand-planer__hex-svg" width="${geom.width}" height="${geom.height}" viewBox="0 0 ${geom.width} ${geom.height}" overflow="hidden" aria-hidden="true">
          <polygon points="${geom.points}" fill="var(--wp-moss-light)" stroke="var(--wp-frame)" stroke-width="${geom.strokePx}"></polygon>
          <circle class="wand-planer__hex-marker" cx="${geom.markerX.toFixed(2)}" cy="${geom.markerY.toFixed(2)}" r="${Math.max(1.8, geom.strokePx * 0.9)}" fill="var(--wp-frame)"></circle>
          <text class="wand-planer__hex-label" x="${geom.labelX}" y="${geom.labelY}" text-anchor="middle" dominant-baseline="central">${item.shapeKey}</text>
        </svg>
      `;
    }

    if (item.kind === 'round') {
      const d = item.cm * pxPerCm;
      const strokePx = mosaicStrokePx(pxPerCm);
      const r = d / 2 - strokePx / 2;
      const cx = d / 2;
      return `
        <svg class="wand-planer__round-svg" width="${d}" height="${d}" viewBox="0 0 ${d} ${d}" overflow="hidden" aria-hidden="true">
          <circle cx="${cx}" cy="${cx}" r="${r}" fill="var(--wp-moss-light)" stroke="var(--wp-frame)" stroke-width="${strokePx}"></circle>
          <text class="wand-planer__hex-label" x="${cx}" y="${cx}" text-anchor="middle" dominant-baseline="central">${ROUND_SIZES[item.shapeKey].label}</text>
        </svg>
      `;
    }

    if (item.kind === 'rect') {
      const swap = rot === 90 || rot === 270;
      const w = (swap ? item.heightCm : item.widthCm) * pxPerCm;
      const h = (swap ? item.widthCm : item.heightCm) * pxPerCm;
      const strokePx = mosaicStrokePx(pxPerCm);
      const inset = strokePx / 2;
      const cx = w / 2;
      const cy = h / 2;
      return `
        <svg class="wand-planer__rect-svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" overflow="hidden" aria-hidden="true">
          <rect x="${inset}" y="${inset}" width="${w - strokePx}" height="${h - strokePx}" rx="4" fill="var(--wp-moss-light)" stroke="var(--wp-frame)" stroke-width="${strokePx}"></rect>
          <text class="wand-planer__hex-label" x="${cx}" y="${cy}" text-anchor="middle" dominant-baseline="central">${RECT_SIZES[item.shapeKey].label}</text>
        </svg>
      `;
    }

    return '';
  }

  function rotationStepForKind(kind) {
    if (kind === 'hex') return 30;
    if (kind === 'rect') return 90;
    return 0;
  }

  function rotationHintText(item) {
    if (!item) return 'Einfach antippen, bis die Ausrichtung passt.';
    const deg = item.rotationDeg || 0;

    if (item.kind === 'rect') {
      return deg === 90 || deg === 270 ? 'Aktuell: Hochformat' : 'Aktuell: Querformat';
    }

    if (item.kind === 'hex') {
      return deg === 0 ? 'Aktuell: Standard' : 'Aktuell: gedreht — nochmal tippen zum Weiterdrehen';
    }

    return 'Einfach antippen, bis die Ausrichtung passt.';
  }

  function canRotateItem(item) {
    return item && (item.kind === 'hex' || item.kind === 'rect');
  }

  function itemToolbarMarkup() {
    return `
      <div class="wand-planer__item-toolbar" role="toolbar" aria-label="Objekt-Aktionen" hidden>
        <button type="button" class="wand-planer__item-tool" data-wand-item-action="rotate" aria-label="Drehen" title="Drehen">
          <svg class="wand-planer__item-tool-icon" viewBox="0 0 16 16" aria-hidden="true">
            <path fill="currentColor" d="M8 3a5 5 0 1 0 4.9 4H10V5h4V1h-1.5l-1.2 1.2A6.5 6.5 0 1 0 8 1.5V3z"></path>
          </svg>
        </button>
        <button type="button" class="wand-planer__item-tool" data-wand-item-action="duplicate" aria-label="Duplizieren" title="Duplizieren">
          <svg class="wand-planer__item-tool-icon" viewBox="0 0 16 16" aria-hidden="true">
            <path fill="currentColor" d="M4 2h7a2 2 0 0 1 2 2v7H9a2 2 0 0 1-2-2V2zm2 2v5a1 1 0 0 0 1 1h5V4H6zm2 3h4a2 2 0 0 1 2 2v4H6a2 2 0 0 1-2-2V7z"></path>
          </svg>
        </button>
        <button type="button" class="wand-planer__item-tool wand-planer__item-tool--danger" data-wand-item-action="delete" aria-label="Entfernen" title="Entfernen">
          <svg class="wand-planer__item-tool-icon" viewBox="0 0 16 16" aria-hidden="true">
            <path fill="currentColor" d="M6 2h4l1 1h3v1H2V3h3l1-1zm-1 4h1v7H5V6zm3 0h1v7H8V6zm3 0h1v7h-1V6zM4 14h8l1-9H3l1 9z"></path>
          </svg>
        </button>
      </div>
    `;
  }

  function syncItemToolbar(el, item, selectedId, selectedIds) {
    const toolbar = el.querySelector('.wand-planer__item-toolbar');
    if (!toolbar) return;

    const ids = selectedIds || new Set(selectedId != null ? [selectedId] : []);
    const showToolbar = ids.size === 1 && ids.has(item.id);
    toolbar.hidden = !showToolbar;

    const rotateBtn = toolbar.querySelector('[data-wand-item-action="rotate"]');
    if (rotateBtn) {
      rotateBtn.hidden = !canRotateItem(item);
    }
  }

  function formatDimCm(cm) {
    const rounded = round1(cm);
    return Number.isInteger(rounded) ? String(rounded) : String(rounded).replace('.', ',');
  }

  function layoutDimensionsSvg(bounds, pxPerCm, wallWidthCm, wallHeightCm) {
    if (!bounds) return '';

    const s = pxPerCm;
    const stroke = Math.max(1, 0.1 * s);
    const tick = Math.max(3, 0.35 * s);
    const off = 2.6 * s;
    const ext = 0.9 * s;
    const fontSize = Math.max(10, Math.min(14, 0.42 * s));
    const color = '#5c8259';
    const boxColor = 'rgba(92, 130, 89, 0.55)';

    const x1 = bounds.minX * s;
    const x2 = bounds.maxX * s;
    const y1 = bounds.minY * s;
    const y2 = bounds.maxY * s;
    const wallW = wallWidthCm * s;
    const wallH = wallHeightCm * s;
    const boxW = x2 - x1;
    const boxH = y2 - y1;

    const widthBelow = y2 + off + fontSize + 4 < wallH;
    const dimY = widthBelow ? y2 + off : y1 - off;
    const widthExtStart = widthBelow ? y2 : y1;
    const widthExtDir = widthBelow ? 1 : -1;

    const heightRight = x2 + off + fontSize + 8 < wallW;
    const dimX = heightRight ? x2 + off : x1 - off;

    const widthLabel = `${formatDimCm(bounds.widthCm)} cm`;
    const heightLabel = `${formatDimCm(bounds.heightCm)} cm`;

    return `
      <svg class="wand-planer__dimensions" width="${wallW}" height="${wallH}" viewBox="0 0 ${wallW} ${wallH}" aria-hidden="true">
        <rect class="wand-planer__dim-box" x="${x1}" y="${y1}" width="${boxW}" height="${boxH}" fill="none" stroke="${boxColor}" stroke-width="${stroke}" stroke-dasharray="${Math.max(4, 0.25 * s)} ${Math.max(3, 0.2 * s)}"></rect>

        <line x1="${x1}" y1="${widthExtStart}" x2="${x1}" y2="${dimY + widthExtDir * ext}" stroke="${color}" stroke-width="${stroke}"></line>
        <line x1="${x2}" y1="${widthExtStart}" x2="${x2}" y2="${dimY + widthExtDir * ext}" stroke="${color}" stroke-width="${stroke}"></line>
        <line x1="${x1}" y1="${dimY}" x2="${x2}" y2="${dimY}" stroke="${color}" stroke-width="${stroke}"></line>
        <line x1="${x1}" y1="${dimY - tick / 2}" x2="${x1}" y2="${dimY + tick / 2}" stroke="${color}" stroke-width="${stroke}"></line>
        <line x1="${x2}" y1="${dimY - tick / 2}" x2="${x2}" y2="${dimY + tick / 2}" stroke="${color}" stroke-width="${stroke}"></line>
        <text class="wand-planer__dim-label" x="${(x1 + x2) / 2}" y="${dimY + (widthBelow ? fontSize * 0.85 : -fontSize * 0.35)}" text-anchor="middle" font-size="${fontSize}" fill="${color}">${widthLabel}</text>

        <line x1="${heightRight ? x2 : x1}" y1="${y1}" x2="${dimX + (heightRight ? ext : -ext)}" y2="${y1}" stroke="${color}" stroke-width="${stroke}"></line>
        <line x1="${heightRight ? x2 : x1}" y1="${y2}" x2="${dimX + (heightRight ? ext : -ext)}" y2="${y2}" stroke="${color}" stroke-width="${stroke}"></line>
        <line x1="${dimX}" y1="${y1}" x2="${dimX}" y2="${y2}" stroke="${color}" stroke-width="${stroke}"></line>
        <line x1="${dimX - tick / 2}" y1="${y1}" x2="${dimX + tick / 2}" y2="${y1}" stroke="${color}" stroke-width="${stroke}"></line>
        <line x1="${dimX - tick / 2}" y1="${y2}" x2="${dimX + tick / 2}" y2="${y2}" stroke="${color}" stroke-width="${stroke}"></line>
        <text class="wand-planer__dim-label" transform="translate(${dimX + (heightRight ? fontSize * 0.65 : -fontSize * 0.65)} ${(y1 + y2) / 2}) rotate(-90)" text-anchor="middle" font-size="${fontSize}" fill="${color}">${heightLabel}</text>
      </svg>
    `;
  }

  function formatMeters(cm) {
    const meters = cm / 100;
    if (Number.isInteger(meters)) return String(meters);
    return meters.toFixed(2).replace('.', ',');
  }

  function refCanvasSvg(refKey, widthPx, heightPx) {
    const w = widthPx;
    const h = heightPx;

    if (refKey === 'person') {
      return personSilhouetteSvg('wand-planer__ref-svg wand-planer__ref-svg--person', w, h);
    }

    if (refKey === 'sofa') {
      const stroke = Math.max(1.4, Math.min(w, h) * 0.018);
      const legH = Math.max(3, h * 0.1);
      const armW = Math.max(6, w * 0.07);
      const backTop = h * 0.06;
      const backH = h * 0.4;
      const seatY = h * 0.42;
      const bodyBottom = h - legH;
      return `
        <svg class="wand-planer__ref-svg wand-planer__ref-svg--sofa" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" aria-hidden="true">
          <rect x="${armW}" y="${backTop}" width="${w - armW * 2}" height="${backH}" rx="${Math.max(2, w * 0.012)}" fill="rgba(120,120,120,0.08)" stroke="currentColor" stroke-width="${stroke}"></rect>
          <rect x="1" y="${seatY}" width="${armW}" height="${bodyBottom - seatY}" rx="${Math.max(2, w * 0.01)}" fill="rgba(120,120,120,0.1)" stroke="currentColor" stroke-width="${stroke}"></rect>
          <rect x="${w - armW - 1}" y="${seatY}" width="${armW}" height="${bodyBottom - seatY}" rx="${Math.max(2, w * 0.01)}" fill="rgba(120,120,120,0.1)" stroke="currentColor" stroke-width="${stroke}"></rect>
          <rect x="${armW}" y="${seatY}" width="${w - armW * 2}" height="${bodyBottom - seatY}" rx="${Math.max(2, w * 0.01)}" fill="rgba(120,120,120,0.06)" stroke="currentColor" stroke-width="${stroke}"></rect>
          <line x1="${armW + w * 0.04}" y1="${(seatY + bodyBottom) / 2}" x2="${w - armW - w * 0.04}" y2="${(seatY + bodyBottom) / 2}" stroke="currentColor" stroke-width="${Math.max(1, stroke * 0.7)}" opacity="0.45"></line>
          <rect x="${armW * 0.55}" y="${bodyBottom}" width="${Math.max(3, armW * 0.45)}" height="${legH - 1}" fill="currentColor" opacity="0.55"></rect>
          <rect x="${w - armW}" y="${bodyBottom}" width="${Math.max(3, armW * 0.45)}" height="${legH - 1}" fill="currentColor" opacity="0.55"></rect>
        </svg>
      `;
    }

    if (refKey === 'sideboard') {
      const stroke = Math.max(1.4, Math.min(w, h) * 0.02);
      const legH = Math.max(3, h * 0.12);
      const top = h * 0.05;
      const bodyH = h - top - legH;
      const inset = Math.max(2, w * 0.04);
      const third = (w - inset * 2) / 3;
      return `
        <svg class="wand-planer__ref-svg wand-planer__ref-svg--sideboard" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" aria-hidden="true">
          <rect x="1" y="${top}" width="${w - 2}" height="${bodyH}" rx="${Math.max(1.5, w * 0.008)}" fill="rgba(120,120,120,0.07)" stroke="currentColor" stroke-width="${stroke}"></rect>
          <line x1="${inset + third}" y1="${top + inset * 0.6}" x2="${inset + third}" y2="${top + bodyH - inset * 0.6}" stroke="currentColor" stroke-width="${Math.max(1, stroke * 0.75)}" opacity="0.55"></line>
          <line x1="${inset + third * 2}" y1="${top + inset * 0.6}" x2="${inset + third * 2}" y2="${top + bodyH - inset * 0.6}" stroke="currentColor" stroke-width="${Math.max(1, stroke * 0.75)}" opacity="0.55"></line>
          <line x1="${inset}" y1="${top + bodyH * 0.5}" x2="${w - inset}" y2="${top + bodyH * 0.5}" stroke="currentColor" stroke-width="${Math.max(1, stroke * 0.7)}" opacity="0.4"></line>
          <rect x="${w * 0.08}" y="${top + bodyH}" width="${Math.max(3, w * 0.035)}" height="${legH - 1}" fill="currentColor" opacity="0.55"></rect>
          <rect x="${w * 0.885}" y="${top + bodyH}" width="${Math.max(3, w * 0.035)}" height="${legH - 1}" fill="currentColor" opacity="0.55"></rect>
        </svg>
      `;
    }

    if (refKey === 'door') {
      const inset = Math.max(2, w * 0.06);
      const stroke = Math.max(1.5, w * 0.022);
      return `
        <svg class="wand-planer__ref-svg wand-planer__ref-svg--door" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" aria-hidden="true">
          <rect x="1" y="1" width="${w - 2}" height="${h - 2}" fill="rgba(120,120,120,0.06)" stroke="currentColor" stroke-width="${stroke}"></rect>
          <rect x="${inset}" y="${inset}" width="${w - inset * 2}" height="${h - inset * 2}" fill="none" stroke="currentColor" stroke-width="${Math.max(1, stroke * 0.75)}"></rect>
          <circle cx="${w * 0.82}" cy="${h * 0.55}" r="${Math.max(2, w * 0.04)}" fill="currentColor"></circle>
        </svg>
      `;
    }

    if (refKey === 'window') {
      const inset = Math.max(2, w * 0.05);
      const stroke = Math.max(1.5, w * 0.018);
      return `
        <svg class="wand-planer__ref-svg wand-planer__ref-svg--window" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" aria-hidden="true">
          <rect x="1" y="1" width="${w - 2}" height="${h - 2}" fill="rgba(120,120,120,0.05)" stroke="currentColor" stroke-width="${stroke}"></rect>
          <rect x="${inset}" y="${inset}" width="${w - inset * 2}" height="${h - inset * 2}" fill="none" stroke="currentColor" stroke-width="${Math.max(1, stroke * 0.75)}"></rect>
          <line x1="${w / 2}" y1="${inset}" x2="${w / 2}" y2="${h - inset}" stroke="currentColor" stroke-width="${Math.max(1, stroke * 0.75)}"></line>
          <line x1="${inset}" y1="${h / 2}" x2="${w - inset}" y2="${h / 2}" stroke="currentColor" stroke-width="${Math.max(1, stroke * 0.75)}"></line>
        </svg>
      `;
    }

    if (refKey === 'outlet') {
      const pad = Math.max(1, w * 0.08);
      const holeR = Math.max(1.2, w * 0.12);
      return `
        <svg class="wand-planer__ref-svg wand-planer__ref-svg--outlet" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" aria-hidden="true">
          <rect x="${pad}" y="${pad}" width="${w - pad * 2}" height="${h - pad * 2}" rx="${w * 0.12}" fill="rgba(120,120,120,0.12)" stroke="currentColor" stroke-width="1.5"></rect>
          <circle cx="${w * 0.38}" cy="${h * 0.5}" r="${holeR}" fill="currentColor"></circle>
          <circle cx="${w * 0.62}" cy="${h * 0.5}" r="${holeR}" fill="currentColor"></circle>
        </svg>
      `;
    }

    return '';
  }

  /** Schlanke Linien-Icons für die Sidebar — ohne Maßangaben */
  function refPreviewSvg(refKey) {
    if (refKey === 'person') {
      return personSilhouetteSvg('wand-planer__ref-preview-person', 14, 38);
    }

    if (refKey === 'sofa') {
      return `
        <svg width="34" height="16" viewBox="0 0 34 16" aria-hidden="true">
          <rect x="6" y="1" width="22" height="6" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"></rect>
          <rect x="1" y="6" width="5" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"></rect>
          <rect x="28" y="6" width="5" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"></rect>
          <rect x="6" y="6" width="22" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"></rect>
          <rect x="3" y="13" width="2" height="2.5" fill="currentColor"></rect>
          <rect x="29" y="13" width="2" height="2.5" fill="currentColor"></rect>
        </svg>
      `;
    }

    if (refKey === 'sideboard') {
      return `
        <svg width="32" height="16" viewBox="0 0 32 16" aria-hidden="true">
          <rect x="1.5" y="1.5" width="29" height="11" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"></rect>
          <line x1="11" y1="2.5" x2="11" y2="11.5" stroke="currentColor" stroke-width="1.1"></line>
          <line x1="21" y1="2.5" x2="21" y2="11.5" stroke="currentColor" stroke-width="1.1"></line>
          <rect x="4" y="12.5" width="2" height="2.5" fill="currentColor"></rect>
          <rect x="26" y="12.5" width="2" height="2.5" fill="currentColor"></rect>
        </svg>
      `;
    }

    if (refKey === 'door') {
      return `
        <svg width="18" height="30" viewBox="0 0 18 30" aria-hidden="true">
          <rect x="1.5" y="1" width="15" height="28" rx="0.5" fill="none" stroke="currentColor" stroke-width="1.4"></rect>
          <circle cx="13.5" cy="16" r="1.1" fill="currentColor"></circle>
        </svg>
      `;
    }

    if (refKey === 'window') {
      return `
        <svg width="26" height="26" viewBox="0 0 26 26" aria-hidden="true">
          <rect x="1.5" y="1.5" width="23" height="23" fill="none" stroke="currentColor" stroke-width="1.4"></rect>
          <line x1="13" y1="1.5" x2="13" y2="24.5" stroke="currentColor" stroke-width="1.2"></line>
          <line x1="1.5" y1="13" x2="24.5" y2="13" stroke="currentColor" stroke-width="1.2"></line>
        </svg>
      `;
    }

    if (refKey === 'outlet') {
      return `
        <svg width="20" height="14" viewBox="0 0 20 14" aria-hidden="true">
          <rect x="1" y="1" width="18" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.3"></rect>
          <circle cx="7.5" cy="7" r="1.3" fill="currentColor"></circle>
          <circle cx="12.5" cy="7" r="1.3" fill="currentColor"></circle>
        </svg>
      `;
    }

    return '';
  }

  function buildRefPreviewSvg(refKey) {
    return refPreviewSvg(refKey);
  }

  class WandPlaner {
    constructor(root) {
      this.root = root;
      this.canvasWrap = root.querySelector('[data-wand-canvas-wrap]');
      this.canvas = root.querySelector('[data-wand-canvas]');
      this.surface = root.querySelector('[data-wand-surface]');
      this.dimensionsLayer = root.querySelector('[data-wand-dimensions]');
      this.wall = root.querySelector('[data-wand-wall]');
      this.floor = root.querySelector('[data-wand-floor]');
      this.wallLabel = root.querySelector('[data-wand-wall-label]');
      this.wallWidthInput = root.querySelector('[data-wand-wall-width]');
      this.wallHeightInput = root.querySelector('[data-wand-wall-height]');
      this.hint = root.querySelector('[data-wand-hint]');
      this.statsEl = root.querySelector('[data-wand-stats]');
      this.btnDuplicate = root.querySelector('[data-wand-duplicate]');
      this.btnDelete = root.querySelector('[data-wand-delete]');
      this.btnReset = root.querySelector('[data-wand-reset]');
      this.btnUndo = root.querySelector('[data-wand-undo]');
      this.btnGroup = root.querySelector('[data-wand-group]');
      this.btnUngroup = root.querySelector('[data-wand-ungroup]');
      this.panelSelect = root.querySelector('[data-wand-panel-select]');
      this.panels = root.querySelectorAll('[data-wand-panel]');
      this.rotateField = root.querySelector('[data-wand-rotate-field]');
      this.rotateBtn = root.querySelector('[data-wand-rotate]');
      this.rotateHint = root.querySelector('[data-wand-rotate-hint]');
      this.refSizeField = root.querySelector('[data-wand-ref-size]');
      this.refWidthInput = root.querySelector('[data-wand-ref-width]');
      this.refHeightInput = root.querySelector('[data-wand-ref-height]');
      this.frameGapSelect = root.querySelector('[data-wand-frame-gap]');
      this.btnCopySummary = root.querySelector('[data-wand-copy-summary]');
      this.btnDownloadSketch = root.querySelector('[data-wand-download-sketch]');
      this.whatsappLink = root.querySelector('[data-wand-whatsapp-link]');
      this.copyFeedback = root.querySelector('[data-wand-copy-feedback]');
      this.shopLinksWrap = root.querySelector('[data-wand-shop-links]');
      this.shopLinksList = root.querySelector('[data-wand-shop-links-list]');
      this.whatsappNumber = (root.dataset.wandWhatsapp || WHATSAPP_DEFAULT).replace(/\D/g, '');

      this.wallWidthCm = DEFAULT_WALL_WIDTH_CM;
      this.wallHeightCm = DEFAULT_WALL_HEIGHT_CM;
      this.mosaicGapCm = 0;
      this.items = [];
      this.selectedId = null;
      this.selectedIds = new Set();
      this.dragState = null;
      this.nextId = 1;
      this.nextGroupId = 1;
      this.pxPerCm = PREVIEW_PX_PER_CM;
      this.undoStack = [];
      this.suppressHistory = false;
      this.persistTimer = null;
      this.dragLayoutRaf = null;
      this.marqueeState = null;
      /** Geladene Set-Vorlage — Shop-Link zeigt Set-Produkt statt Einzelstücke */
      this.activeSetId = null;

      this.restoreState();

      this.wallWidthInput.value = String(this.wallWidthCm);
      this.wallHeightInput.value = String(this.wallHeightCm);
      if (this.frameGapSelect) {
        this.frameGapSelect.value = String(this.mosaicGapCm);
      }

      this.bindEvents();
      requestAnimationFrame(() => {
        this.applyWallSize();
        this.rerenderAllItems();
        this.updateUI();
      });
    }

    bindEvents() {
      this.root.querySelectorAll('[data-wand-add-kind]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.addMosaicItem(btn.dataset.wandAddKind, btn.dataset.wandAdd);
        });
      });

      this.root.querySelectorAll('[data-wand-add-ref]').forEach((btn) => {
        btn.addEventListener('click', () => this.addRefItem(btn.dataset.wandAddRef));
      });

      this.root.querySelectorAll('[data-wand-load-set]').forEach((btn) => {
        btn.addEventListener('click', () => this.loadSetTemplate(btn.dataset.wandLoadSet));
      });

      if (this.panelSelect) {
        this.panelSelect.addEventListener('change', () => this.switchPanel(this.panelSelect.value));
      }

      if (this.rotateBtn) {
        this.rotateBtn.addEventListener('click', () => this.rotateSelected());
      }

      if (this.refWidthInput) {
        this.refWidthInput.addEventListener('change', () => this.applySelectedRefSizeFromInputs());
        this.refWidthInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.applySelectedRefSizeFromInputs();
            this.refWidthInput.blur();
          }
        });
      }
      if (this.refHeightInput) {
        this.refHeightInput.addEventListener('change', () => this.applySelectedRefSizeFromInputs());
        this.refHeightInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.applySelectedRefSizeFromInputs();
            this.refHeightInput.blur();
          }
        });
      }

      this.btnDuplicate.addEventListener('click', () => this.duplicateSelected());
      this.btnDelete.addEventListener('click', () => this.deleteSelected());
      this.btnReset.addEventListener('click', () => this.resetAll());
      if (this.btnUndo) {
        this.btnUndo.addEventListener('click', () => this.undo());
      }
      if (this.btnGroup) {
        this.btnGroup.addEventListener('click', () => this.groupSelected());
      }
      if (this.btnUngroup) {
        this.btnUngroup.addEventListener('click', () => this.ungroupSelected());
      }
      if (this.btnCopySummary) {
        this.btnCopySummary.addEventListener('click', () => this.copyLayoutSummary());
      }
      if (this.btnDownloadSketch) {
        this.btnDownloadSketch.addEventListener('click', () => this.downloadSketch());
      }
      if (this.whatsappLink) {
        this.whatsappLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.openWhatsAppAdvice();
        });
      }

      window.addEventListener('keydown', (e) => this.onGlobalKeyDown(e));

      this.wallWidthInput.addEventListener('change', () => this.commitWallWidth());
      this.wallHeightInput.addEventListener('change', () => this.commitWallHeight());

      [this.wallWidthInput, this.wallHeightInput].forEach((input) => {
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            input.blur();
          }
        });
      });

      if (this.frameGapSelect) {
        this.frameGapSelect.addEventListener('change', () => this.onFrameGapChange());
      }

      this.surface.addEventListener('pointerdown', (e) => this.onSurfacePointerDown(e));

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(() => this.applyWallSize());
        observer.observe(this.canvasWrap);
      } else {
        window.addEventListener('resize', () => this.applyWallSize());
      }
    }

    captureSnapshot() {
      return {
        items: JSON.parse(JSON.stringify(this.items)),
        selectedId: this.selectedId,
        selectedIds: [...this.selectedIds],
        nextId: this.nextId,
        nextGroupId: this.nextGroupId,
        activeSetId: this.activeSetId,
      };
    }

    pushHistory() {
      if (this.suppressHistory) return;
      this.undoStack.push(this.captureSnapshot());
      if (this.undoStack.length > UNDO_STACK_MAX) {
        this.undoStack.shift();
      }
      this.updateUndoButton();
    }

    pushSnapshot(snapshot) {
      if (this.suppressHistory || !snapshot) return;
      this.undoStack.push(snapshot);
      if (this.undoStack.length > UNDO_STACK_MAX) {
        this.undoStack.shift();
      }
      this.updateUndoButton();
    }

    updateUndoButton() {
      if (this.btnUndo) {
        this.btnUndo.disabled = this.undoStack.length === 0;
      }
    }

    undo() {
      if (!this.undoStack.length) return;
      const snapshot = this.undoStack.pop();
      this.updateUndoButton();

      this.surface.querySelectorAll('.wand-planer__item').forEach((el) => el.remove());
      this.items = JSON.parse(JSON.stringify(snapshot.items)).map(normalizePersistedItem);
      this.selectedId = snapshot.selectedId;
      this.selectedIds = new Set(
        Array.isArray(snapshot.selectedIds)
          ? snapshot.selectedIds
          : snapshot.selectedId != null
            ? [snapshot.selectedId]
            : []
      );
      if (typeof snapshot.nextId === 'number') {
        this.nextId = snapshot.nextId;
      }
      if (typeof snapshot.nextGroupId === 'number') {
        this.nextGroupId = snapshot.nextGroupId;
      }
      this.activeSetId =
        typeof snapshot.activeSetId === 'string' && SET_TEMPLATES[snapshot.activeSetId]
          ? snapshot.activeSetId
          : null;

      this.rerenderAllItems();
      this.refreshSelectionUI();
      this.updateUI();
    }

    schedulePersist() {
      if (this.persistTimer) clearTimeout(this.persistTimer);
      this.persistTimer = setTimeout(() => this.persistState(), 300);
    }

    persistState() {
      try {
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            items: this.items,
            wallWidthCm: this.wallWidthCm,
            wallHeightCm: this.wallHeightCm,
            mosaicGapCm: this.mosaicGapCm,
            nextId: this.nextId,
            nextGroupId: this.nextGroupId,
            activeSetId: this.activeSetId,
          })
        );
      } catch (_) {
        /* Private Mode / Quota */
      }
    }

    restoreState() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const data = JSON.parse(raw);
        if (!data || !Array.isArray(data.items)) return false;

        this.items = data.items.map(normalizePersistedItem);
        this.nextId =
          typeof data.nextId === 'number'
            ? data.nextId
            : this.items.reduce((max, item) => Math.max(max, item.id || 0), 0) + 1;
        const maxGroupId = this.items.reduce(
          (max, item) => Math.max(max, item.groupId || 0),
          0
        );
        this.nextGroupId =
          typeof data.nextGroupId === 'number' ? data.nextGroupId : maxGroupId + 1;
        if (typeof data.wallWidthCm === 'number') {
          this.wallWidthCm = clamp(data.wallWidthCm, WALL_WIDTH_MIN_CM, WALL_WIDTH_MAX_CM);
        }
        if (typeof data.wallHeightCm === 'number') {
          this.wallHeightCm = clamp(data.wallHeightCm, WALL_HEIGHT_MIN_CM, WALL_HEIGHT_MAX_CM);
        }
        if (typeof data.mosaicGapCm === 'number') {
          this.mosaicGapCm = Math.max(0, data.mosaicGapCm);
        }
        this.activeSetId =
          typeof data.activeSetId === 'string' && SET_TEMPLATES[data.activeSetId]
            ? data.activeSetId
            : null;
        this.selectedId = null;
        this.selectedIds = new Set();
        return true;
      } catch (_) {
        this.items = [];
        this.nextId = 1;
        return false;
      }
    }

    onGlobalKeyDown(e) {
      if ((e.ctrlKey || e.metaKey) && String(e.key).toLowerCase() === 'z') {
        if (e.target.closest('input, textarea, select')) return;
        e.preventDefault();
        this.undo();
      }
    }

    onItemKeyDown(e, id) {
      const item = this.items.find((i) => i.id === id);
      if (!item) return;

      const key = e.key;
      const step = e.shiftKey ? 5 : 1;
      const moveIds = this.getMoveTargetIds(item);

      if (key === 'ArrowLeft' || key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowDown') {
        e.preventDefault();
        this.selectItem(id);
        this.pushHistory();
        const dx = key === 'ArrowLeft' ? -step : key === 'ArrowRight' ? step : 0;
        const dy = key === 'ArrowUp' ? -step : key === 'ArrowDown' ? step : 0;
        moveIds.forEach((moveId) => {
          const moveItem = this.items.find((i) => i.id === moveId);
          if (!moveItem) return;
          moveItem.xCm = round1(moveItem.xCm + dx);
          moveItem.yCm = round1(moveItem.yCm + dy);
          this.renderItem(moveItem);
        });
        clampItemsToWall(this.items, moveIds, this.wallWidthCm, this.wallHeightCm);
        moveIds.forEach((moveId) => {
          const moveItem = this.items.find((i) => i.id === moveId);
          if (moveItem) this.renderItem(moveItem);
        });
        this.updateUI();
        return;
      }

      if (key === 'Delete' || key === 'Backspace') {
        e.preventDefault();
        this.selectItem(id);
        this.deleteSelected();
        return;
      }

      if (key === 'r' || key === 'R') {
        if (!canRotateItem(item) || moveIds.length > 1) return;
        e.preventDefault();
        this.selectItem(id);
        this.rotateSelected();
      }
    }

    getMoveTargetIds(item) {
      if (item.groupId) return getGroupMemberIds(this.items, item.groupId);
      if (this.selectedIds.size > 1 && this.selectedIds.has(item.id)) {
        return [...this.selectedIds];
      }
      return [item.id];
    }

    clientPointToWallCm(clientX, clientY) {
      const rect = this.surface.getBoundingClientRect();
      return {
        xCm: (clientX - rect.left) / this.pxPerCm,
        yCm: (clientY - rect.top) / this.pxPerCm,
      };
    }

    ensureMarqueeEl() {
      let el = this.surface.querySelector('.wand-planer__marquee');
      if (!el) {
        el = document.createElement('div');
        el.className = 'wand-planer__marquee';
        el.setAttribute('aria-hidden', 'true');
        this.surface.appendChild(el);
      }
      return el;
    }

    updateMarqueeEl(startXCm, startYCm, endXCm, endYCm) {
      const el = this.ensureMarqueeEl();
      const minX = Math.min(startXCm, endXCm);
      const minY = Math.min(startYCm, endYCm);
      const width = Math.abs(endXCm - startXCm);
      const height = Math.abs(endYCm - startYCm);
      el.removeAttribute('hidden');
      el.classList.add('is-visible');
      el.style.left = `${minX * this.pxPerCm}px`;
      el.style.top = `${minY * this.pxPerCm}px`;
      el.style.width = `${Math.max(width * this.pxPerCm, 2)}px`;
      el.style.height = `${Math.max(height * this.pxPerCm, 2)}px`;
    }

    clearMarqueeEl() {
      const el = this.surface.querySelector('.wand-planer__marquee');
      if (el) {
        el.classList.remove('is-visible');
        el.setAttribute('hidden', '');
        el.style.width = '0';
        el.style.height = '0';
      }
    }

    onSurfacePointerDown(e) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      if (e.target.closest('.wand-planer__item')) return;
      if (e.target.closest('.wand-planer__item-toolbar')) return;

      const start = this.clientPointToWallCm(e.clientX, e.clientY);
      this.marqueeState = {
        pointerId: e.pointerId,
        startXCm: start.xCm,
        startYCm: start.yCm,
        endXCm: start.xCm,
        endYCm: start.yCm,
        additive: Boolean(e.shiftKey),
        moved: false,
      };

      this.surface.setPointerCapture(e.pointerId);
      this.surface.classList.add('is-marquee');

      const onMove = (ev) => this.onMarqueeMove(ev);
      const onUp = (ev) => {
        this.surface.removeEventListener('pointermove', onMove);
        this.surface.removeEventListener('pointerup', onUp);
        this.surface.removeEventListener('pointercancel', onUp);
        this.onMarqueeUp(ev);
      };

      this.surface.addEventListener('pointermove', onMove);
      this.surface.addEventListener('pointerup', onUp);
      this.surface.addEventListener('pointercancel', onUp);
    }

    onMarqueeMove(e) {
      if (!this.marqueeState || e.pointerId !== this.marqueeState.pointerId) return;

      const point = this.clientPointToWallCm(e.clientX, e.clientY);
      this.marqueeState.endXCm = point.xCm;
      this.marqueeState.endYCm = point.yCm;

      const dx = Math.abs(this.marqueeState.endXCm - this.marqueeState.startXCm);
      const dy = Math.abs(this.marqueeState.endYCm - this.marqueeState.startYCm);
      if (dx > 0.15 || dy > 0.15) {
        this.marqueeState.moved = true;
      }

      if (this.marqueeState.moved) {
        this.updateMarqueeEl(
          this.marqueeState.startXCm,
          this.marqueeState.startYCm,
          this.marqueeState.endXCm,
          this.marqueeState.endYCm
        );
        this.previewMarqueeSelection();
      }
    }

    getMarqueeBoundsCm(state) {
      return {
        minX: Math.min(state.startXCm, state.endXCm),
        minY: Math.min(state.startYCm, state.endYCm),
        maxX: Math.max(state.startXCm, state.endXCm),
        maxY: Math.max(state.startYCm, state.endYCm),
      };
    }

    collectIdsInMarquee(bounds) {
      const ids = [];
      this.items.forEach((item) => {
        if (!isMosaicItem(item)) return;
        const box = getItemWorldBounds(item);
        const intersects =
          box.minX < bounds.maxX &&
          box.maxX > bounds.minX &&
          box.minY < bounds.maxY &&
          box.maxY > bounds.minY;
        if (intersects) ids.push(item.id);
      });
      return ids;
    }

    previewMarqueeSelection() {
      if (!this.marqueeState || !this.marqueeState.moved) return;
      const bounds = this.getMarqueeBoundsCm(this.marqueeState);
      const hitIds = this.collectIdsInMarquee(bounds);
      const next = this.marqueeState.additive
        ? new Set([...this.selectedIds, ...hitIds])
        : new Set(hitIds);

      this.surface.querySelectorAll('.wand-planer__item').forEach((el) => {
        const itemId = Number(el.dataset.itemId);
        el.classList.toggle('is-marquee-hit', hitIds.includes(itemId));
        el.classList.toggle('is-selected', next.has(itemId));
      });
    }

    onMarqueeUp(e) {
      this.surface.classList.remove('is-marquee');
      this.clearMarqueeEl();
      this.surface.querySelectorAll('.wand-planer__item.is-marquee-hit').forEach((el) => {
        el.classList.remove('is-marquee-hit');
      });

      const state = this.marqueeState;
      this.marqueeState = null;
      if (!state) return;

      if (!state.moved) {
        if (!state.additive) this.selectItem(null);
        return;
      }

      const bounds = this.getMarqueeBoundsCm(state);
      const hitIds = this.collectIdsInMarquee(bounds);

      if (state.additive) {
        hitIds.forEach((id) => this.selectedIds.add(id));
        this.selectedId = hitIds[hitIds.length - 1] ?? this.selectedId;
      } else {
        this.selectedIds = new Set(hitIds);
        this.selectedId = hitIds[0] ?? null;
      }

      // Gruppenmitglieder mitnehmen, wenn eines getroffen wurde
      const withGroups = new Set(this.selectedIds);
      this.selectedIds.forEach((id) => {
        const item = this.items.find((i) => i.id === id);
        if (item?.groupId) {
          getGroupMemberIds(this.items, item.groupId).forEach((gid) => withGroups.add(gid));
        }
      });
      this.selectedIds = withGroups;
      if (this.selectedId == null && this.selectedIds.size) {
        this.selectedId = [...this.selectedIds][0];
      }

      this.refreshSelectionUI();
      this.updateUI();
    }

    getDragTargetIds(item) {
      return this.getMoveTargetIds(item);
    }

    getSelectedMosaicIds() {
      return [...this.selectedIds].filter((id) => {
        const item = this.items.find((i) => i.id === id);
        return item && isMosaicItem(item);
      });
    }

    groupSelected() {
      const mosaicIds = this.getSelectedMosaicIds();
      if (mosaicIds.length < 2) return;

      this.pushHistory();
      const groupId = this.nextGroupId++;
      mosaicIds.forEach((id) => {
        const item = this.items.find((i) => i.id === id);
        if (item) item.groupId = groupId;
      });
      this.refreshSelectionUI();
      this.updateUI();
    }

    ungroupSelected() {
      const groupIds = new Set();
      this.getSelectedMosaicIds().forEach((id) => {
        const item = this.items.find((i) => i.id === id);
        if (item?.groupId) groupIds.add(item.groupId);
      });
      if (!groupIds.size) return;

      this.pushHistory();
      this.items.forEach((item) => {
        if (item.groupId && groupIds.has(item.groupId)) {
          delete item.groupId;
        }
      });
      this.refreshSelectionUI();
      this.updateUI();
    }

    toggleSelectItem(id) {
      const item = this.items.find((i) => i.id === id);
      if (!item) return;

      if (this.selectedIds.has(id)) {
        this.selectedIds.delete(id);
        if (this.selectedId === id) {
          const next = [...this.selectedIds].pop();
          this.selectedId = next ?? null;
        }
      } else {
        this.selectedIds.add(id);
        this.selectedId = id;
      }
      this.refreshSelectionUI();
    }

    selectItem(id, options = {}) {
      if (id == null) {
        this.selectedId = null;
        this.selectedIds.clear();
        this.refreshSelectionUI();
        return;
      }

      const item = this.items.find((i) => i.id === id);
      if (!item) return;

      if (options.additive) {
        this.toggleSelectItem(id);
        return;
      }

      if (item.groupId) {
        this.selectedIds = new Set(getGroupMemberIds(this.items, item.groupId));
        this.selectedId = id;
      } else {
        this.selectedIds = new Set([id]);
        this.selectedId = id;
      }
      this.refreshSelectionUI();
    }

    refreshSelectionUI() {
      const activeGroupIds = new Set();
      this.selectedIds.forEach((id) => {
        const item = this.items.find((i) => i.id === id);
        if (item?.groupId) activeGroupIds.add(item.groupId);
      });

      this.surface.querySelectorAll('.wand-planer__item').forEach((el) => {
        const itemId = Number(el.dataset.itemId);
        const item = this.items.find((i) => i.id === itemId);
        const selected = this.selectedIds.has(itemId);
        el.classList.toggle('is-selected', selected);
        el.classList.toggle('is-in-group', Boolean(item?.groupId));
        el.classList.toggle(
          'is-group-active',
          Boolean(item?.groupId && activeGroupIds.has(item.groupId))
        );
        if (item) syncItemToolbar(el, item, this.selectedId, this.selectedIds);
      });
      this.updateActionButtons();
    }

    scheduleDragLayoutUpdate() {
      if (this.dragLayoutRaf) return;
      this.dragLayoutRaf = requestAnimationFrame(() => {
        this.dragLayoutRaf = null;
        this.updateLayoutDimensions();
      });
    }

    getPxPerCm() {
      const wrap = this.canvasWrap;
      if (!wrap) return PREVIEW_PX_PER_CM;

      const wrapW = wrap.clientWidth;
      const wrapH = wrap.clientHeight;
      if (!wrapW || !wrapH) return PREVIEW_PX_PER_CM;

      let padX = 24;
      let padY = 24;
      if (this.canvas) {
        const canvasStyle = getComputedStyle(this.canvas);
        padX = parseFloat(canvasStyle.paddingLeft) + parseFloat(canvasStyle.paddingRight);
        padY = parseFloat(canvasStyle.paddingTop) + parseFloat(canvasStyle.paddingBottom);
      }

      const floorPx = this.floor ? this.floor.offsetHeight : 18;
      const availW = Math.max(wrapW - padX, 40);
      const availH = Math.max(wrapH - padY - floorPx, 40);

      const scaleW = availW / this.wallWidthCm;
      const scaleH = availH / this.wallHeightCm;
      return Math.min(scaleW, scaleH);
    }

    onFrameGapChange() {
      const parsed = parseFloat(this.frameGapSelect.value);
      const newGap = Number.isNaN(parsed) ? 0 : Math.max(0, parsed);
      const oldGap = this.mosaicGapCm;
      if (newGap === oldGap) return;

      this.pushHistory();
      this.mosaicGapCm = newGap;

      // Bestehende Kontakte mitziehen (wichtig bei S/M/L-Mix) — nicht nur neu einrasten
      const redistributed = this.redistributeHexGap(oldGap, newGap);
      if (!redistributed) {
        this.resnapAllMosaicItems();
      }

      this.updateUI();
    }

    /**
     * Abstand ändern: erkannte Nachbar-Paare auf neuen Kontaktabstand lockern/ziehen.
     * Hält den Schwerpunkt — verhindert das „Ineinanderschieben“ bei gemischten Größen.
     */
    redistributeHexGap(oldGap, newGap) {
      const hexes = this.items.filter((item) => item.kind === 'hex');
      if (hexes.length < 2) return false;

      const pairs = findHexContactPairs(this.items, oldGap, 3.5);
      if (!pairs.length) return false;

      const targets = pairs
        .map(({ a, b, ox, oy }) => {
          const matched = matchNeighborDelta(b.cm, a.cm, newGap, a.rotationDeg || 0, ox, oy);
          if (!matched || matched.cos < 0.7) return null;
          return { a, b, tx: matched.dx, ty: matched.dy };
        })
        .filter(Boolean);

      if (!targets.length) return false;

      const centroid = hexes.reduce(
        (acc, item) => {
          const c = getHexWorldCenter(item);
          return { x: acc.x + c.x, y: acc.y + c.y };
        },
        { x: 0, y: 0 }
      );
      centroid.x /= hexes.length;
      centroid.y /= hexes.length;

      for (let iter = 0; iter < 60; iter += 1) {
        targets.forEach(({ a, b, tx, ty }) => {
          const ca = getHexWorldCenter(a);
          const cb = getHexWorldCenter(b);
          const ex = tx - (cb.x - ca.x);
          const ey = ty - (cb.y - ca.y);
          a.xCm += -ex * 0.5;
          a.yCm += -ey * 0.5;
          b.xCm += ex * 0.5;
          b.yCm += ey * 0.5;
        });
      }

      const after = hexes.reduce(
        (acc, item) => {
          const c = getHexWorldCenter(item);
          return { x: acc.x + c.x, y: acc.y + c.y };
        },
        { x: 0, y: 0 }
      );
      after.x /= hexes.length;
      after.y /= hexes.length;
      const shiftX = centroid.x - after.x;
      const shiftY = centroid.y - after.y;

      hexes.forEach((item) => {
        item.xCm = round1(item.xCm + shiftX);
        item.yCm = round1(item.yCm + shiftY);
        this.renderItem(item);
      });

      return true;
    }

    resnapAllMosaicItems() {
      for (let pass = 0; pass < 2; pass += 1) {
        this.items
          .filter((item) => isMosaicItem(item))
          .forEach((item) => {
            const snapped = this.snapItem(item, item.xCm, item.yCm, true);
            item.xCm = snapped.xCm;
            item.yCm = snapped.yCm;
            this.renderItem(item);
          });
      }
    }

    snapItem(item, xCm, yCm, relaxed = false) {
      return snapMosaicPosition(
        item,
        xCm,
        yCm,
        this.items,
        this.wallWidthCm,
        this.wallHeightCm,
        this.mosaicGapCm,
        { relaxed }
      );
    }

    commitWallWidth() {
      const parsed = parseWallMeasure(this.wallWidthInput.value, WALL_WIDTH_MIN_CM, WALL_WIDTH_MAX_CM);
      if (parsed === null) {
        this.wallWidthInput.value = String(this.wallWidthCm);
        return;
      }

      this.wallWidthInput.value = String(parsed);

      if (parsed === this.wallWidthCm) return;

      this.wallWidthCm = parsed;
      this.applyWallSize();
      this.rerenderAllItems();
      this.updateUI();
      trackWandPlaner('wandplaner_wall_resized', {
        width_cm: this.wallWidthCm,
        height_cm: this.wallHeightCm,
      });
    }

    commitWallHeight() {
      const parsed = parseWallMeasure(this.wallHeightInput.value, WALL_HEIGHT_MIN_CM, WALL_HEIGHT_MAX_CM);
      if (parsed === null) {
        this.wallHeightInput.value = String(this.wallHeightCm);
        return;
      }

      this.wallHeightInput.value = String(parsed);

      if (parsed === this.wallHeightCm) return;

      this.wallHeightCm = parsed;
      this.applyWallSize();
      this.rerenderAllItems();
      this.updateUI();
      trackWandPlaner('wandplaner_wall_resized', {
        width_cm: this.wallWidthCm,
        height_cm: this.wallHeightCm,
      });
    }

    applyWallSize() {
      const prevPxPerCm = this.pxPerCm;
      this.pxPerCm = this.getPxPerCm();

      const wallWidthPx = Math.round(this.wallWidthCm * this.pxPerCm);
      const wallHeightPx = Math.round(this.wallHeightCm * this.pxPerCm);

      this.root.style.setProperty('--wp-px-per-cm', String(this.pxPerCm));
      this.root.style.setProperty('--wp-grid-cm', '10');
      this.root.style.setProperty('--wp-wall-width-cm', String(this.wallWidthCm));
      this.root.style.setProperty('--wp-wall-height-cm', String(this.wallHeightCm));
      this.root.style.setProperty('--wp-wall-width-px', String(wallWidthPx));
      this.root.style.setProperty('--wp-wall-height-px', String(wallHeightPx));

      if (this.wall) {
        this.wall.style.width = `${wallWidthPx}px`;
      }

      if (this.surface) {
        this.surface.style.width = `${wallWidthPx}px`;
        this.surface.style.height = `${wallHeightPx}px`;
      }

      if (this.wallLabel) {
        this.wallLabel.textContent =
          `Musterwand: ${this.wallWidthCm} × ${this.wallHeightCm} cm ` +
          `(${formatMeters(this.wallWidthCm)} × ${formatMeters(this.wallHeightCm)} m)`;
      }

      if (this.items.length && Math.abs(prevPxPerCm - this.pxPerCm) > 0.001) {
        this.rerenderAllItems();
        this.updateStats();
      } else {
        this.updateLayoutDimensions();
      }
    }

    getDefaultRefPosition(refKey) {
      const ref = REF_TYPES[refKey];
      const xCm = round1(this.wallWidthCm / 2 - ref.widthCm / 2);

      if (ref.floorAlign === true) {
        return { xCm, yCm: round1(this.wallHeightCm - ref.heightCm) };
      }

      if (ref.floorAlign === 'outlet') {
        const centerFromTop = this.wallHeightCm - OUTLET_HEIGHT_ABOVE_FLOOR_CM;
        return {
          xCm,
          yCm: round1(centerFromTop - ref.heightCm / 2),
        };
      }

      return { xCm, yCm: round1(this.wallHeightCm / 2 - ref.heightCm / 2) };
    }

    switchPanel(panelId) {
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.wandPanel !== panelId;
      });
    }

    getDefaultMosaicPosition(kind, shapeKey) {
      const spec = getMosaicSpec(kind, shapeKey);
      if (!spec) return { xCm: 0, yCm: 0 };

      let widthCm;
      let heightCm;
      if (kind === 'rect') {
        widthCm = spec.widthCm;
        heightCm = spec.heightCm;
      } else if (kind === 'round') {
        widthCm = spec.cm;
        heightCm = spec.cm;
      } else {
        widthCm = spec.cm;
        heightCm = hexHeightCm(spec.cm);
      }

      return {
        xCm: round1(this.wallWidthCm / 2 - widthCm / 2),
        yCm: round1(this.wallHeightCm / 2 - heightCm / 2),
      };
    }

    /** Freie Startposition: kein Stapel auf bestehenden Moosbildern */
    findFreeMosaicPosition(kind, shapeKey, rotationDeg = 0) {
      const spec = getMosaicSpec(kind, shapeKey);
      if (!spec) return { xCm: 0, yCm: 0 };

      const probe = {
        id: -1,
        kind,
        shapeKey,
        rotationDeg: rotationDeg || 0,
      };
      if (kind === 'rect') {
        probe.widthCm = spec.widthCm;
        probe.heightCm = spec.heightCm;
      } else {
        probe.cm = spec.cm;
      }

      const mosaics = this.items.filter((item) => isMosaicItem(item));
      const isFree = (xCm, yCm) => {
        const bounds = getMosaicWorldBoundsAt(probe, xCm, yCm);
        if (!mosaicBoundsInsideWall(bounds, this.wallWidthCm, this.wallHeightCm)) {
          return false;
        }
        return !mosaics.some((other) =>
          mosaicBoundsOverlap(bounds, getItemWorldBounds(other))
        );
      };

      const center = this.getDefaultMosaicPosition(kind, shapeKey);
      if (isFree(center.xCm, center.yCm)) {
        return center;
      }

      if (kind === 'hex') {
        for (const other of mosaics) {
          if (other.kind !== 'hex') continue;
          const slots = collectHexSnapSlots(probe, other, this.mosaicGapCm);
          for (const slot of slots) {
            if (slot.kind === 'align-x' || slot.kind === 'align-y') continue;
            if (isFree(slot.xCm, slot.yCm)) {
              return { xCm: round1(slot.xCm), yCm: round1(slot.yCm) };
            }
          }
        }
      }

      const step = 5;
      for (let ring = 1; ring <= 48; ring += 1) {
        for (let dx = -ring; dx <= ring; dx += 1) {
          for (let dy = -ring; dy <= ring; dy += 1) {
            if (Math.max(Math.abs(dx), Math.abs(dy)) !== ring) continue;
            const xCm = round1(center.xCm + dx * step);
            const yCm = round1(center.yCm + dy * step);
            if (isFree(xCm, yCm)) {
              return { xCm, yCm };
            }
          }
        }
      }

      return center;
    }

    clearActiveSetIfEditing() {
      if (this.suppressHistory) return;
      this.activeSetId = null;
    }

    addMosaicItem(kind, shapeKey, xCm, yCm, options) {
      const spec = getMosaicSpec(kind, shapeKey);
      if (!spec) return null;

      this.pushHistory();
      this.clearActiveSetIfEditing();

      const rotationDeg = options?.rotationDeg ?? 0;
      const defaults =
        xCm == null || yCm == null
          ? this.findFreeMosaicPosition(kind, shapeKey, rotationDeg)
          : { xCm, yCm };
      const item = {
        id: this.nextId++,
        kind,
        shapeKey,
        xCm: xCm ?? defaults.xCm,
        yCm: yCm ?? defaults.yCm,
        rotationDeg,
      };

      if (kind === 'rect') {
        item.widthCm = spec.widthCm;
        item.heightCm = spec.heightCm;
      } else {
        item.cm = spec.cm;
      }

      this.items.push(item);
      if (!options?.skipSnap) {
        const snapped = this.snapItem(item, item.xCm, item.yCm, true);
        item.xCm = snapped.xCm;
        item.yCm = snapped.yCm;
      } else {
        item.xCm = round1(item.xCm);
        item.yCm = round1(item.yCm);
      }
      this.renderItem(item);
      if (!options || !options.silentSelect) {
        this.selectItem(item.id);
      }
      if (!options || !options.deferUi) {
        this.updateUI();
      }
      if (!options || !options.skipTrack) {
        trackWandPlaner('wandplaner_item_added', { kind, shape_key: shapeKey });
      }
      return item;
    }

    addHexItem(shapeKey, xCm, yCm, options) {
      return this.addMosaicItem('hex', shapeKey, xCm, yCm, options);
    }

    addRefItem(refKey, xCm, yCm) {
      const ref = REF_TYPES[refKey];
      if (!ref) return;

      this.pushHistory();

      const defaults = this.getDefaultRefPosition(refKey);
      const item = {
        id: this.nextId++,
        kind: 'ref',
        refKey,
        widthCm: ref.widthCm,
        heightCm: ref.heightCm,
        xCm: xCm ?? defaults.xCm,
        yCm: yCm ?? defaults.yCm,
      };

      this.items.push(item);
      this.renderItem(item);
      this.selectItem(item.id);
      this.updateUI();
    }

    rerenderAllItems() {
      this.items.forEach((item) => this.renderItem(item));
    }

    getItemSize(item) {
      return getItemUnrotatedSize(item);
    }

    renderItem(item) {
      let el = this.surface.querySelector(`[data-item-id="${item.id}"]`);

      if (!el) {
        el = document.createElement('div');
        el.className = 'wand-planer__item';
        el.dataset.itemId = String(item.id);
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.innerHTML = `<div class="wand-planer__item-visual"></div>${itemToolbarMarkup()}`;

        el.addEventListener('pointerdown', (e) => {
          e.stopPropagation();
          if (e.target.closest('.wand-planer__item-toolbar')) return;
          this.onItemPointerDown(e, Number(el.dataset.itemId));
        });

        el.addEventListener('keydown', (e) => {
          this.onItemKeyDown(e, Number(el.dataset.itemId));
        });

        el.addEventListener('click', (e) => {
          const actionBtn = e.target.closest('[data-wand-item-action]');
          if (actionBtn) {
            e.preventDefault();
            e.stopPropagation();
            this.handleItemToolbarAction(Number(el.dataset.itemId), actionBtn.dataset.wandItemAction);
            return;
          }
          e.stopPropagation();
        });

        this.surface.appendChild(el);
      }

      const visual = el.querySelector('.wand-planer__item-visual');
      if (!visual) return;

      el.classList.toggle('wand-planer__item--hex', item.kind === 'hex');
      el.classList.toggle('wand-planer__item--round', item.kind === 'round');
      el.classList.toggle('wand-planer__item--rect', item.kind === 'rect');
      el.classList.toggle('wand-planer__item--ref', item.kind === 'ref');

      if (isMosaicItem(item)) {
        el.setAttribute('aria-label', `${mosaicTitle(item)} auf der Wand`);
        visual.innerHTML = renderMosaicSvg(item, this.pxPerCm);
        applyItemTransform(el, item, this.pxPerCm);
      } else {
        const widthPx = item.widthCm * this.pxPerCm;
        const heightPx = item.heightCm * this.pxPerCm;
        el.setAttribute('aria-label', `${refDisplayTitle(item)} auf der Wand`);
        visual.innerHTML = refCanvasSvg(item.refKey, widthPx, heightPx);
        el.style.transformOrigin = '';
        el.style.transform = `translate(${item.xCm * this.pxPerCm}px, ${item.yCm * this.pxPerCm}px)`;
      }

      el.classList.toggle('is-selected', this.selectedIds.has(item.id));
      el.classList.toggle('is-in-group', Boolean(item.groupId));
      el.classList.toggle(
        'is-group-active',
        Boolean(item.groupId && [...this.selectedIds].some((sid) => {
          const sel = this.items.find((i) => i.id === sid);
          return sel?.groupId === item.groupId;
        }))
      );
      el.classList.toggle(
        'wand-planer__item--toolbar-below',
        item.yCm * this.pxPerCm < TOOLBAR_FLIP_PX
      );
      el.classList.toggle('wand-planer__item--hit-pad', this.pxPerCm < 2);
      syncItemToolbar(el, item, this.selectedId, this.selectedIds);
    }

    onItemPointerDown(e, id) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;

      const item = this.items.find((i) => i.id === id);
      if (!item) return;

      if (e.shiftKey) {
        this.selectItem(id, { additive: true });
      } else {
        this.selectItem(id);
      }

      const dragIds = this.getDragTargetIds(item);
      const origins = {};
      dragIds.forEach((dragId) => {
        const dragItem = this.items.find((i) => i.id === dragId);
        if (dragItem) {
          origins[dragId] = { xCm: dragItem.xCm, yCm: dragItem.yCm };
        }
      });

      const el = this.surface.querySelector(`[data-item-id="${id}"]`);
      el.setPointerCapture(e.pointerId);
      dragIds.forEach((dragId) => {
        const dragEl = this.surface.querySelector(`[data-item-id="${dragId}"]`);
        if (dragEl) dragEl.classList.add('is-dragging');
      });

      this.dragState = {
        id,
        dragIds,
        origins,
        isGroupDrag: dragIds.length > 1,
        pointerId: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        originXCm: item.xCm,
        originYCm: item.yCm,
        el,
        undoSnapshot: this.captureSnapshot(),
        moved: false,
      };

      const onMove = (ev) => this.onPointerMove(ev);
      const onUp = (ev) => {
        el.removeEventListener('pointermove', onMove);
        el.removeEventListener('pointerup', onUp);
        el.removeEventListener('pointercancel', onUp);
        if (this.dragLayoutRaf) {
          cancelAnimationFrame(this.dragLayoutRaf);
          this.dragLayoutRaf = null;
        }
        if (this.dragState) {
          const { dragIds: finishedIds, isGroupDrag } = this.dragState;
          if (isGroupDrag) {
            clampItemsToWall(this.items, finishedIds, this.wallWidthCm, this.wallHeightCm);
            finishedIds.forEach((dragId) => {
              const dragItem = this.items.find((i) => i.id === dragId);
              if (dragItem) this.renderItem(dragItem);
            });
          } else {
            const dragged = this.items.find((i) => i.id === this.dragState.id);
            if (dragged && isMosaicItem(dragged)) {
              const snapped = this.snapItem(dragged, dragged.xCm, dragged.yCm, true);
              dragged.xCm = snapped.xCm;
              dragged.yCm = snapped.yCm;
              this.renderItem(dragged);
            }
          }
          finishedIds.forEach((dragId) => {
            const dragEl = this.surface.querySelector(`[data-item-id="${dragId}"]`);
            if (dragEl) dragEl.classList.remove('is-dragging');
          });
          this.surface.classList.remove('is-snapping');
          if (this.dragState.moved) {
            this.pushSnapshot(this.dragState.undoSnapshot);
          }
        }
        this.dragState = null;
        this.updateUI();
      };

      el.addEventListener('pointermove', onMove);
      el.addEventListener('pointerup', onUp);
      el.addEventListener('pointercancel', onUp);
    }

    onPointerMove(e) {
      if (!this.dragState || e.pointerId !== this.dragState.pointerId) return;

      const item = this.items.find((i) => i.id === this.dragState.id);
      if (!item) return;

      const dxCm = (e.clientX - this.dragState.startX) / this.pxPerCm;
      const dyCm = (e.clientY - this.dragState.startY) / this.pxPerCm;

      if (this.dragState.isGroupDrag) {
        this.dragState.dragIds.forEach((dragId) => {
          const dragItem = this.items.find((i) => i.id === dragId);
          const origin = this.dragState.origins[dragId];
          if (!dragItem || !origin) return;
          dragItem.xCm = round1(origin.xCm + dxCm);
          dragItem.yCm = round1(origin.yCm + dyCm);
          const dragEl = this.surface.querySelector(`[data-item-id="${dragId}"]`);
          if (dragEl) {
            if (isMosaicItem(dragItem)) {
              applyItemTransform(dragEl, dragItem, this.pxPerCm);
            } else {
              dragEl.style.transform = `translate(${dragItem.xCm * this.pxPerCm}px, ${dragItem.yCm * this.pxPerCm}px)`;
            }
          }
        });
        this.dragState.moved =
          Math.abs(dxCm) > 0.05 || Math.abs(dyCm) > 0.05;
        this.surface.classList.remove('is-snapping');
        this.scheduleDragLayoutUpdate();
        return;
      }

      const snapped = this.snapItem(
        item,
        this.dragState.originXCm + dxCm,
        this.dragState.originYCm + dyCm,
        isMosaicItem(item) && item.kind === 'hex'
      );

      item.xCm = snapped.xCm;
      item.yCm = snapped.yCm;
      this.dragState.moved =
        Math.abs(item.xCm - this.dragState.originXCm) > 0.05 ||
        Math.abs(item.yCm - this.dragState.originYCm) > 0.05;
      this.surface.classList.toggle('is-snapping', snapped.snapped);

      if (isMosaicItem(item)) {
        applyItemTransform(this.dragState.el, item, this.pxPerCm);
      } else {
        this.dragState.el.style.transform = `translate(${item.xCm * this.pxPerCm}px, ${item.yCm * this.pxPerCm}px)`;
      }
      this.scheduleDragLayoutUpdate();
    }

    handleItemToolbarAction(id, action) {
      this.selectItem(id);

      if (action === 'rotate') this.rotateSelected();
      else if (action === 'duplicate') this.duplicateSelected();
      else if (action === 'delete') this.deleteSelected();
    }

    rotateSelected() {
      const item = this.items.find((i) => i.id === this.selectedId);
      if (!item || !canRotateItem(item) || item.groupId) return;

      this.pushHistory();

      const step = rotationStepForKind(item.kind);

      if (item.kind === 'hex') {
        const oldLocal = getHexLocalBounds(item.cm, item.rotationDeg || 0);
        const centerX = item.xCm + (oldLocal.minX + oldLocal.maxX) / 2;
        const centerY = item.yCm + (oldLocal.minY + oldLocal.maxY) / 2;
        item.rotationDeg = ((item.rotationDeg || 0) + step) % 360;
        const newLocal = getHexLocalBounds(item.cm, item.rotationDeg);
        item.xCm = round1(centerX - (newLocal.minX + newLocal.maxX) / 2);
        item.yCm = round1(centerY - (newLocal.minY + newLocal.maxY) / 2);
      } else {
        item.rotationDeg = ((item.rotationDeg || 0) + step) % 360;
      }

      this.renderItem(item);
      this.updateRotationControl();
      this.updateUI();
    }

    deleteSelected() {
      const ids = [...this.selectedIds];
      if (!ids.length && this.selectedId) ids.push(this.selectedId);
      if (!ids.length) return;

      this.pushHistory();
      ids.forEach((id) => {
        const el = this.surface.querySelector(`[data-item-id="${id}"]`);
        if (el) el.remove();
      });
      this.items = this.items.filter((i) => !ids.includes(i.id));
      this.selectedId = null;
      this.selectedIds.clear();
      this.clearActiveSetIfEditing();
      this.updateUI();
    }

    clearMosaicItems() {
      this.items = this.items.filter((item) => !isMosaicItem(item));
      this.surface
        .querySelectorAll('.wand-planer__item--hex, .wand-planer__item--round, .wand-planer__item--rect')
        .forEach((el) => el.remove());
      if (this.selectedId) {
        const stillSelected = this.items.some((item) => item.id === this.selectedId);
        if (!stillSelected) {
          this.selectedId = null;
          this.selectedIds.clear();
        }
      }
    }

    duplicateSelected() {
      const item = this.items.find((i) => i.id === this.selectedId);
      if (!item) return;

      if (isMosaicItem(item)) {
        let offsetX = 5;
        let offsetY = 5;
        const gap = this.mosaicGapCm;

        if (item.kind === 'hex') {
          const hs = hexRowSpacingCm(item.cm);
          const vs = hexColSpacingCm(item.cm);
          const leftNeighbor = this.items
            .filter(
              (other) =>
                other.id !== item.id &&
                other.kind === 'hex' &&
                other.cm === item.cm &&
                (other.rotationDeg || 0) === (item.rotationDeg || 0) &&
                other.xCm < item.xCm - 0.5
            )
            .sort((a, b) => item.xCm - a.xCm - (item.xCm - b.xCm))[0];

          let stepX = hs;
          let stepY = -vs;
          if (leftNeighbor) {
            stepY = item.yCm < leftNeighbor.yCm ? vs : -vs;
          }

          const gapped = applyGapToOffset(stepX, stepY, gap);
          offsetX = gapped.dx;
          offsetY = gapped.dy;
        } else if (item.kind === 'round') {
          const local = getMosaicLocalBounds(item);
          offsetX = local.widthCm + gap;
          offsetY = 0;
        } else if (item.kind === 'rect') {
          const local = getMosaicLocalBounds(item);
          offsetX = local.widthCm + gap;
          offsetY = 0;
        }

        this.addMosaicItem(item.kind, item.shapeKey, item.xCm + offsetX, item.yCm + offsetY, {
          rotationDeg: item.rotationDeg || 0,
        });
        return;
      }

      this.addRefItem(item.refKey, item.xCm + 5, item.yCm + 5);
    }

    loadSetTemplate(templateId) {
      const template = SET_TEMPLATES[templateId];
      if (!template) return;

      this.pushHistory();
      this.suppressHistory = true;
      const createdIds = [];
      try {
        this.clearMosaicItems();

        const centerX = this.wallWidthCm / 2;
        const centerY = this.wallHeightCm / 2;
        const placements = template.build(centerX, centerY);

        placements.forEach((placement) => {
          const item = this.addHexItem(placement.sizeKey, placement.xCm, placement.yCm, {
            silentSelect: true,
            deferUi: true,
            skipSnap: true,
            skipTrack: true,
          });
          if (item?.id) createdIds.push(item.id);
        });

        if (createdIds.length > 1) {
          const groupId = this.nextGroupId++;
          createdIds.forEach((id) => {
            const item = this.items.find((entry) => entry.id === id);
            if (item) item.groupId = groupId;
          });
          this.selectedIds = new Set(createdIds);
          this.selectedId = createdIds[0];
        }

        this.activeSetId = template.productHandle ? templateId : null;
      } finally {
        this.suppressHistory = false;
      }

      this.updateUI();
      trackWandPlaner('wandplaner_set_loaded', { set_id: templateId });
    }

    resetAll() {
      if (!this.items.length) return;
      this.pushHistory();
      this.items = [];
      this.selectedId = null;
      this.selectedIds.clear();
      this.activeSetId = null;
      this.surface.querySelectorAll('.wand-planer__item').forEach((el) => el.remove());
      this.updateUI();
    }

    getLayoutBounds() {
      const mosaicItems = this.items.filter((item) => isMosaicItem(item));
      if (!mosaicItems.length) return null;

      let minX = Infinity;
      let minY = Infinity;
      let maxX = -Infinity;
      let maxY = -Infinity;

      mosaicItems.forEach((item) => {
        const bounds = getItemWorldBounds(item);
        minX = Math.min(minX, bounds.minX);
        minY = Math.min(minY, bounds.minY);
        maxX = Math.max(maxX, bounds.maxX);
        maxY = Math.max(maxY, bounds.maxY);
      });

      const widthCm = round1(maxX - minX);
      const heightCm = round1(maxY - minY);
      const tolerance = 0.5;

      return {
        widthCm,
        heightCm,
        minX,
        minY,
        maxX,
        maxY,
        exceedsWidth: widthCm > this.wallWidthCm + tolerance,
        exceedsHeight: heightCm > this.wallHeightCm + tolerance,
        overflowsWidth: minX < -tolerance || maxX > this.wallWidthCm + tolerance,
        overflowsHeight: minY < -tolerance || maxY > this.wallHeightCm + tolerance,
      };
    }

    collectMosaicInventory() {
      const hexCounts = { S: 0, M: 0, L: 0 };
      const roundCounts = { R30: 0, R40: 0, R50: 0, R70: 0 };
      const rectCounts = { REC2097: 0, REC30117: 0, REC40147: 0, REC4520: 0 };
      let refCount = 0;

      this.items.forEach((item) => {
        if (item.kind === 'hex' && hexCounts[item.shapeKey] !== undefined) {
          hexCounts[item.shapeKey] += 1;
        } else if (item.kind === 'round' && roundCounts[item.shapeKey] !== undefined) {
          roundCounts[item.shapeKey] += 1;
        } else if (item.kind === 'rect' && rectCounts[item.shapeKey] !== undefined) {
          rectCounts[item.shapeKey] += 1;
        } else if (item.kind === 'ref') {
          refCount += 1;
        }
      });

      return { hexCounts, roundCounts, rectCounts, refCount };
    }

    buildLayoutSummaryText() {
      const { hexCounts, roundCounts, rectCounts, refCount } = this.collectMosaicInventory();
      const mosaicTotal = this.items.filter((item) => isMosaicItem(item)).length;
      const bounds = this.getLayoutBounds();
      const lines = [
        'Hallo MoosSchmiede,',
        '',
        'ich habe im Wand-Planer eine Anordnung skizziert:',
        '',
        `Wand: ${this.wallWidthCm} × ${this.wallHeightCm} cm`,
        `Abstand zwischen Rahmen: ${this.mosaicGapCm} cm`,
      ];

      if (bounds) {
        lines.push(`Layout ca.: ${formatDimCm(bounds.widthCm)} × ${formatDimCm(bounds.heightCm)} cm`);
      }

      lines.push('');
      lines.push(`Moosbilder gesamt: ${mosaicTotal}`);

      if (hexCounts.S) lines.push(`- Hexagon S (21 cm): ${hexCounts.S}×`);
      if (hexCounts.M) lines.push(`- Hexagon M (26 cm): ${hexCounts.M}×`);
      if (hexCounts.L) lines.push(`- Hexagon L (31 cm): ${hexCounts.L}×`);

      Object.keys(roundCounts).forEach((key) => {
        if (roundCounts[key]) {
          lines.push(`- Rund ${ROUND_SIZES[key].label} cm: ${roundCounts[key]}×`);
        }
      });
      Object.keys(rectCounts).forEach((key) => {
        if (rectCounts[key]) {
          lines.push(`- Rechteck ${RECT_SIZES[key].label} cm: ${rectCounts[key]}×`);
        }
      });

      if (refCount) {
        const furniture = this.items.filter(
          (item) => item.kind === 'ref' && (item.refKey === 'sofa' || item.refKey === 'sideboard')
        );
        if (furniture.length) {
          furniture.forEach((item) => {
            lines.push(`- ${refDisplayTitle(item)}`);
          });
          const otherRefs = refCount - furniture.length;
          if (otherRefs > 0) lines.push(`- Weitere Raum-Hilfen: ${otherRefs}×`);
        } else {
          lines.push(`- Raum-Hilfen: ${refCount}×`);
        }
      }

      lines.push('');
      lines.push(
        'Ich schicke dir gerne noch die Skizze als Bild (gespeichert aus dem Planer) oder ein Foto meiner Wand mit — dann könnt ihr mir einen Vorschlag machen.'
      );
      lines.push('');
      lines.push('Danke!');

      return lines.join('\n');
    }

    async copyLayoutSummary() {
      const text = this.buildLayoutSummaryText();
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        this.showCopyFeedback('Text kopiert — du kannst ihn z. B. in WhatsApp einfügen.');
        trackWandPlaner('wandplaner_text_copied', {});
      } catch (_) {
        this.showCopyFeedback('Kopieren hat nicht geklappt — nutze „Per WhatsApp fragen“.');
      }
    }

    showCopyFeedback(message) {
      if (!this.copyFeedback) return;
      this.copyFeedback.hidden = false;
      this.copyFeedback.textContent = message;
      clearTimeout(this.copyFeedbackTimer);
      this.copyFeedbackTimer = setTimeout(() => {
        this.copyFeedback.hidden = true;
      }, 4000);
    }

    openWhatsAppAdvice() {
      const mosaicCount = this.items.filter((item) => isMosaicItem(item)).length;
      trackWandPlaner('wandplaner_whatsapp_click', { item_count: mosaicCount });
      const text = this.buildLayoutSummaryText();
      const url = `https://wa.me/${this.whatsappNumber}?text=${encodeURIComponent(text)}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    getShopLinkEntries() {
      const { hexCounts, roundCounts, rectCounts } = this.collectMosaicInventory();
      const entries = [];
      const byUrl = new Map();

      const add = (url, label, count) => {
        if (!url || url === '#' || !count) return;
        if (byUrl.has(url)) {
          const existing = byUrl.get(url);
          existing.count += count;
          if (!existing.label.includes(label)) {
            existing.label = `${existing.label} · ${label}`;
          }
          return;
        }
        const entry = { url, label, count };
        byUrl.set(url, entry);
        entries.push(entry);
      };

      const activeSet = this.activeSetId ? SET_TEMPLATES[this.activeSetId] : null;
      if (activeSet?.productHandle) {
        add(
          `https://moosschmiede.de/products/${activeSet.productHandle}`,
          `Set ${activeSet.name} (${activeSet.meta})`,
          1
        );
        return entries;
      }

      if (hexCounts.S || hexCounts.M || hexCounts.L) {
        const parts = [];
        if (hexCounts.S) parts.push(`${hexCounts.S}× S`);
        if (hexCounts.M) parts.push(`${hexCounts.M}× M`);
        if (hexCounts.L) parts.push(`${hexCounts.L}× L`);
        add(PRODUCT_URLS.S, `Hexagon (${parts.join(', ')})`, hexCounts.S + hexCounts.M + hexCounts.L);
      }

      Object.keys(roundCounts).forEach((key) => {
        add(PRODUCT_URLS[key], `Rund ${ROUND_SIZES[key].label} cm`, roundCounts[key]);
      });
      Object.keys(rectCounts).forEach((key) => {
        add(PRODUCT_URLS[key], `Rechteck ${RECT_SIZES[key].label}`, rectCounts[key]);
      });

      return entries;
    }

    updateShopLinks() {
      if (!this.shopLinksWrap || !this.shopLinksList) return;
      const entries = this.getShopLinkEntries();
      const hasMosaic = this.items.some((item) => isMosaicItem(item));

      if (this.btnCopySummary) this.btnCopySummary.disabled = !hasMosaic;
      if (this.btnDownloadSketch) this.btnDownloadSketch.disabled = !hasMosaic;

      if (!entries.length) {
        this.shopLinksWrap.hidden = true;
        this.shopLinksList.innerHTML = '';
        return;
      }

      this.shopLinksWrap.hidden = false;
      this.shopLinksList.innerHTML = entries
        .map(
          (entry) =>
            `<li><a href="${entry.url}" target="_blank" rel="noopener">${entry.label}</a></li>`
        )
        .join('');
    }

    downloadSketch() {
      const mosaicItems = this.items.filter((item) => isMosaicItem(item) || item.kind === 'ref');
      if (!mosaicItems.length) return;

      const scale = 4;
      const pad = 16 * scale;
      const wallW = this.wallWidthCm * scale;
      const wallH = this.wallHeightCm * scale;
      const floorH = 14 * scale;
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(wallW + pad * 2);
      canvas.height = Math.round(wallH + floorH + pad * 2);
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.fillStyle = '#f7f6f1';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#ebeae2';
      ctx.fillRect(pad, pad, wallW, wallH);
      ctx.strokeStyle = '#c5c9b8';
      ctx.lineWidth = Math.max(1, scale * 0.35);
      ctx.strokeRect(pad + 0.5, pad + 0.5, wallW - 1, wallH - 1);

      // light grid every 50 cm
      ctx.strokeStyle = 'rgba(140, 150, 130, 0.22)';
      ctx.lineWidth = 1;
      for (let x = 50; x < this.wallWidthCm; x += 50) {
        const px = pad + x * scale;
        ctx.beginPath();
        ctx.moveTo(px, pad);
        ctx.lineTo(px, pad + wallH);
        ctx.stroke();
      }
      for (let y = 50; y < this.wallHeightCm; y += 50) {
        const py = pad + y * scale;
        ctx.beginPath();
        ctx.moveTo(pad, py);
        ctx.lineTo(pad + wallW, py);
        ctx.stroke();
      }

      mosaicItems.forEach((item) => {
        if (item.kind === 'hex') {
          this.drawExportHex(ctx, item, pad, scale);
        } else if (item.kind === 'round') {
          this.drawExportRound(ctx, item, pad, scale);
        } else if (item.kind === 'rect') {
          this.drawExportRect(ctx, item, pad, scale);
        } else if (item.kind === 'ref') {
          this.drawExportRef(ctx, item, pad, scale);
        }
      });

      ctx.fillStyle = '#d7d4c8';
      ctx.fillRect(pad, pad + wallH, wallW, floorH);
      ctx.fillStyle = '#6b6b63';
      ctx.font = `${Math.max(10, 3.2 * scale)}px sans-serif`;
      ctx.fillText(
        `MoosSchmiede Wand-Planer · ${this.wallWidthCm}×${this.wallHeightCm} cm`,
        pad,
        pad + wallH + floorH - 3 * scale
      );

      const filename = `moosschmiede-wand-skizze-${this.wallWidthCm}x${this.wallHeightCm}.png`;
      const finishSaved = (message) => {
        trackWandPlaner('wandplaner_sketch_saved', {});
        this.showCopyFeedback(message || 'Skizze gespeichert — am besten in WhatsApp mitschicken.');
      };

      const openBlobInNewTab = (blob) => {
        const url = URL.createObjectURL(blob);
        const opened = window.open(url, '_blank', 'noopener,noreferrer');
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
        if (!opened) {
          this.showCopyFeedback('Popup blockiert — erlaube Popups oder nutze „Per WhatsApp fragen“.');
          return;
        }
        finishSaved('Bild geöffnet — gedrückt halten zum Speichern, dann in WhatsApp teilen.');
      };

      const tryDownloadBlob = (blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = filename;
        link.href = url;
        link.rel = 'noopener';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
        finishSaved('Skizze gespeichert — am besten in WhatsApp mitschicken.');
      };

      const exportBlob = (blob) => {
        if (!blob) {
          this.showCopyFeedback('Skizze konnte nicht erzeugt werden — bitte nochmal versuchen.');
          return;
        }

        const file = new File([blob], filename, { type: 'image/png' });
        const shareData = { files: [file], title: 'MoosSchmiede Wand-Skizze' };
        const canShareFiles =
          typeof navigator.canShare === 'function' &&
          typeof navigator.share === 'function' &&
          navigator.canShare(shareData);

        const ua = navigator.userAgent || '';
        const isIOS =
          /iPad|iPhone|iPod/.test(ua) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        if (canShareFiles) {
          navigator
            .share(shareData)
            .then(() => {
              finishSaved('Skizze geteilt — z. B. direkt an uns in WhatsApp.');
            })
            .catch((err) => {
              if (err && err.name === 'AbortError') return;
              if (isIOS) openBlobInNewTab(blob);
              else tryDownloadBlob(blob);
            });
          return;
        }

        if (isIOS) {
          openBlobInNewTab(blob);
          return;
        }

        tryDownloadBlob(blob);
      };

      if (typeof canvas.toBlob === 'function') {
        canvas.toBlob(exportBlob, 'image/png');
        return;
      }

      // Sehr alte Browser: Data-URL-Fallback
      const link = document.createElement('a');
      link.download = filename;
      link.href = canvas.toDataURL('image/png');
      link.click();
      finishSaved('Skizze gespeichert — am besten in WhatsApp mitschicken.');
    }

    drawExportHex(ctx, item, pad, scale) {
      const geom = hexGeometry(item.cm, scale, item.rotationDeg || 0);
      const ox = pad + item.xCm * scale;
      const oy = pad + item.yCm * scale;
      const points = geom.points.split(' ').map((pair) => {
        const [x, y] = pair.split(',').map(Number);
        return { x: ox + x, y: oy + y };
      });
      ctx.beginPath();
      points.forEach((p, i) => {
        if (i === 0) ctx.moveTo(p.x, p.y);
        else ctx.lineTo(p.x, p.y);
      });
      ctx.closePath();
      ctx.fillStyle = 'rgba(119, 174, 115, 0.55)';
      ctx.strokeStyle = '#5c4a3a';
      ctx.lineWidth = Math.max(1.5, scale * 0.55);
      ctx.fill();
      ctx.stroke();
      ctx.fillStyle = '#2f2f2a';
      ctx.font = `bold ${Math.max(10, item.cm * scale * 0.28)}px sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(item.shapeKey, ox + geom.width / 2, oy + geom.height / 2);
    }

    drawExportRound(ctx, item, pad, scale) {
      const d = item.cm * scale;
      const cx = pad + item.xCm * scale + d / 2;
      const cy = pad + item.yCm * scale + d / 2;
      const stroke = Math.max(1.5, scale * 0.55);
      ctx.beginPath();
      ctx.arc(cx, cy, d / 2 - stroke / 2, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(119, 174, 115, 0.55)';
      ctx.strokeStyle = '#5c4a3a';
      ctx.lineWidth = stroke;
      ctx.fill();
      ctx.stroke();
      ctx.fillStyle = '#2f2f2a';
      ctx.font = `bold ${Math.max(10, item.cm * scale * 0.22)}px sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(ROUND_SIZES[item.shapeKey]?.label || '', cx, cy);
    }

    drawExportRect(ctx, item, pad, scale) {
      const local = getMosaicLocalBounds(item);
      const x = pad + (item.xCm + local.minX) * scale;
      const y = pad + (item.yCm + local.minY) * scale;
      const w = local.widthCm * scale;
      const h = local.heightCm * scale;
      const stroke = Math.max(1.5, scale * 0.55);
      const r = Math.min(6, Math.min(w, h) * 0.08);
      ctx.beginPath();
      if (ctx.roundRect) {
        ctx.roundRect(x + stroke / 2, y + stroke / 2, w - stroke, h - stroke, r);
      } else {
        ctx.rect(x + stroke / 2, y + stroke / 2, w - stroke, h - stroke);
      }
      ctx.fillStyle = 'rgba(119, 174, 115, 0.55)';
      ctx.strokeStyle = '#5c4a3a';
      ctx.lineWidth = stroke;
      ctx.fill();
      ctx.stroke();
      ctx.fillStyle = '#2f2f2a';
      ctx.font = `bold ${Math.max(9, Math.min(w, h) * 0.18)}px sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(RECT_SIZES[item.shapeKey]?.label || '', x + w / 2, y + h / 2);
    }

    drawExportRef(ctx, item, pad, scale) {
      const x = pad + item.xCm * scale;
      const y = pad + item.yCm * scale;
      const w = item.widthCm * scale;
      const h = item.heightCm * scale;
      ctx.strokeStyle = 'rgba(90, 90, 90, 0.65)';
      ctx.fillStyle = 'rgba(120, 120, 120, 0.12)';
      ctx.lineWidth = Math.max(1, scale * 0.35);
      ctx.fillRect(x, y, w, h);
      ctx.strokeRect(x, y, w, h);
      ctx.fillStyle = '#555';
      ctx.font = `${Math.max(9, 2.8 * scale)}px sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(refDisplayTitle(item), x + w / 2, y + h / 2);
    }

    updateStats() {
      const { hexCounts, roundCounts, rectCounts, refCount } = this.collectMosaicInventory();
      const total = this.items.filter((item) => isMosaicItem(item)).length;
      const bounds = this.getLayoutBounds();

      let html = `<span><strong>${total}</strong> Moosbild${total === 1 ? '' : 'er'}</span>`;
      const detailParts = [];
      if (hexCounts.S) detailParts.push(`S: ${hexCounts.S}`);
      if (hexCounts.M) detailParts.push(`M: ${hexCounts.M}`);
      if (hexCounts.L) detailParts.push(`L: ${hexCounts.L}`);
      Object.keys(roundCounts).forEach((key) => {
        if (roundCounts[key] > 0) detailParts.push(`Rund ${ROUND_SIZES[key].label}: ${roundCounts[key]}`);
      });
      Object.keys(rectCounts).forEach((key) => {
        if (rectCounts[key] > 0) detailParts.push(`Rechteck ${RECT_SIZES[key].label}: ${rectCounts[key]}`);
      });
      if (detailParts.length) {
        html += `<span>${detailParts.join(' · ')}</span>`;
      }
      if (refCount) {
        html += `<span><strong>${refCount}</strong> Raum-Hilfe${refCount === 1 ? '' : 'n'}</span>`;
      }
      if (bounds) {
        html += `<span>Layout ca. <strong>${formatDimCm(bounds.widthCm)} × ${formatDimCm(bounds.heightCm)} cm</strong></span>`;
        if (bounds.exceedsWidth) {
          html += `<span class="wand-planer__stats-warn">Breiter als deine Wand (${this.wallWidthCm} cm)</span>`;
        } else if (bounds.overflowsWidth) {
          html += `<span class="wand-planer__stats-warn">Ragt seitlich über den Wandrand</span>`;
        }
        if (bounds.exceedsHeight) {
          html += `<span class="wand-planer__stats-warn">Höher als deine Wand (${this.wallHeightCm} cm)</span>`;
        } else if (bounds.overflowsHeight) {
          html += `<span class="wand-planer__stats-warn">Ragt oben oder unten über den Wandrand</span>`;
        }
      }

      this.statsEl.innerHTML = html;
      this.updateShopLinks();
      this.updateLayoutDimensions();
    }

    updateLayoutDimensions() {
      if (!this.dimensionsLayer) return;

      const bounds = this.getLayoutBounds();
      if (!bounds) {
        this.dimensionsLayer.innerHTML = '';
        this.dimensionsLayer.hidden = true;
        return;
      }

      this.dimensionsLayer.hidden = false;
      this.dimensionsLayer.innerHTML = layoutDimensionsSvg(
        bounds,
        this.pxPerCm,
        this.wallWidthCm,
        this.wallHeightCm
      );
    }

    updateRotationControl() {
      if (!this.rotateField || !this.rotateBtn) return;

      const item = this.items.find((i) => i.id === this.selectedId);
      if (!canRotateItem(item) || item?.groupId) {
        this.rotateField.hidden = true;
        this.rotateBtn.disabled = true;
        if (this.rotateHint) {
          this.rotateHint.textContent = 'Einfach antippen, bis die Ausrichtung passt.';
        }
        return;
      }

      this.rotateField.hidden = false;
      this.rotateBtn.disabled = false;
      if (this.rotateHint) {
        this.rotateHint.textContent = rotationHintText(item);
      }
    }

    updateRefSizeControl() {
      if (!this.refSizeField) return;

      const item = this.items.find((i) => i.id === this.selectedId);
      const ref = item?.kind === 'ref' ? REF_TYPES[item.refKey] : null;
      const show = Boolean(ref?.resizable) && this.selectedIds.size <= 1;

      this.refSizeField.hidden = !show;
      if (!show || !this.refWidthInput || !this.refHeightInput) return;

      this.refWidthInput.value = String(item.widthCm).replace('.', ',');
      this.refHeightInput.value = String(item.heightCm).replace('.', ',');
      this.refWidthInput.min = String(ref.minWidthCm);
      this.refWidthInput.max = String(ref.maxWidthCm);
      this.refHeightInput.min = String(ref.minHeightCm);
      this.refHeightInput.max = String(ref.maxHeightCm);
    }

    applySelectedRefSizeFromInputs() {
      if (!this.refWidthInput || !this.refHeightInput) return;
      const item = this.items.find((i) => i.id === this.selectedId);
      const ref = item?.kind === 'ref' ? REF_TYPES[item.refKey] : null;
      if (!ref?.resizable) return;

      const widthCm = parseCmInput(this.refWidthInput.value, ref.minWidthCm, ref.maxWidthCm);
      const heightCm = parseCmInput(this.refHeightInput.value, ref.minHeightCm, ref.maxHeightCm);
      if (widthCm == null || heightCm == null) {
        this.updateRefSizeControl();
        return;
      }

      if (widthCm === item.widthCm && heightCm === item.heightCm) {
        this.updateRefSizeControl();
        return;
      }

      this.pushHistory();
      item.widthCm = widthCm;
      item.heightCm = heightCm;

      if (ref.floorAlign === true) {
        item.yCm = round1(this.wallHeightCm - item.heightCm);
      }
      item.xCm = clamp(item.xCm, 0, Math.max(0, this.wallWidthCm - item.widthCm));
      item.yCm = clamp(item.yCm, 0, Math.max(0, this.wallHeightCm - item.heightCm));

      this.renderItem(item);
      this.updateUI();
    }

    updateActionButtons() {
      const selectionCount = this.selectedIds.size || (this.selectedId ? 1 : 0);
      const mosaicSelected = this.getSelectedMosaicIds();
      const hasGroupedSelection = mosaicSelected.some((id) => {
        const item = this.items.find((i) => i.id === id);
        return Boolean(item?.groupId);
      });

      this.btnDuplicate.disabled = selectionCount !== 1;
      this.btnDelete.disabled = selectionCount === 0;
      if (this.btnGroup) {
        this.btnGroup.disabled = mosaicSelected.length < 2;
      }
      if (this.btnUngroup) {
        this.btnUngroup.disabled = !hasGroupedSelection;
      }
      this.updateUndoButton();
      this.updateRotationControl();
      this.updateRefSizeControl();
    }

    updateUI() {
      if (this.hint) {
        this.hint.hidden = this.items.length > 0;
      }
      this.updateStats();
      this.updateActionButtons();
      this.schedulePersist();
    }
  }

  function buildPreviewSvg(kind, shapeKey) {
    if (kind === 'hex') {
      const size = SIZES[shapeKey];
      if (!size) return '';
      // Relative Größen: L füllt die Preview-Breite, S/M proportional kleiner
      const maxPreviewW = 36;
      const scale = maxPreviewW / SIZES.L.cm;
      const geom = hexGeometry(size.cm, scale);
      const stroke = Math.max(1.2, geom.strokePx);
      return `<svg width="${geom.width.toFixed(1)}" height="${geom.height.toFixed(1)}" viewBox="0 0 ${geom.width} ${geom.height}" aria-hidden="true"><polygon points="${geom.points}" fill="#8fbc8a" stroke="#3d3d3d" stroke-width="${stroke}"></polygon></svg>`;
    }

    if (kind === 'round') {
      const size = ROUND_SIZES[shapeKey];
      if (!size) return '';
      const maxD = 28;
      const scale = maxD / ROUND_SIZES.R70.cm;
      const d = Math.max(12, size.cm * scale);
      return `<svg width="${d.toFixed(1)}" height="${d.toFixed(1)}" viewBox="0 0 ${d} ${d}" aria-hidden="true"><circle cx="${d / 2}" cy="${d / 2}" r="${d / 2 - 1.5}" fill="#8fbc8a" stroke="#3d3d3d" stroke-width="1.5"></circle></svg>`;
    }

    if (kind === 'rect') {
      const size = RECT_SIZES[shapeKey];
      if (!size) return '';
      const scale = PREVIEW_PX_PER_CM;
      let w = size.widthCm * scale;
      let h = size.heightCm * scale;
      const maxW = 36;
      if (w > maxW) {
        h = (h * maxW) / w;
        w = maxW;
      }
      return `<svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" aria-hidden="true"><rect x="1" y="1" width="${w - 2}" height="${h - 2}" rx="3" fill="#8fbc8a" stroke="#3d3d3d" stroke-width="2"></rect></svg>`;
    }

    return '';
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-wand-planer]');
    if (!root) return;

    root.querySelectorAll('[data-wand-preview]').forEach((preview) => {
      const raw = preview.dataset.wandPreview || '';
      const [kind, shapeKey] = raw.split(':');
      if (kind && shapeKey) preview.innerHTML = buildPreviewSvg(kind, shapeKey);
    });

    root.querySelectorAll('[data-wand-ref-preview]').forEach((preview) => {
      const refKey = preview.dataset.wandRefPreview;
      preview.innerHTML = buildRefPreviewSvg(refKey);
    });

    const planer = new WandPlaner(root);
    if (planer.panelSelect) {
      planer.switchPanel(planer.panelSelect.value);
    }
  });
})();
